import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    ENGLISH: {
        translation: {
            "Dashboard": "Dashboard",
            "APPOINTMENT": "APPOINTMENT",
            "CHECKUP LIST": "CHECKUP LIST",
            "PATIENTS": "PATIENTS",
            "IPD": "IPD",
            "STAFF": "STAFF",
            "PHARMACY": "PHARMACY",
            "OPD BILLING": "OPD BILLING",
            "OPD REPORTS": "OPD REPORTS",
            "CONFIG": "CONFIG",
            "LOGOUT": "LOGOUT",
            "Hospital Information": "Hospital Information",
            "System Configuration": "System Configuration",
            "Privacy Policy": "Privacy Policy",
            "Application Language": "Application Language",
            "Save System Config": "Save System Config",
            "Save Hospital Info": "Save Hospital Info",
            "Billing Statements": "Billing Statements",
            "Start Date": "Start Date",
            "End Date": "End Date",
            "SUBMIT": "SUBMIT",
            "CLEAR": "CLEAR",
            "Outstanding Only": "Outstanding Only",
            "Search Name or Mobile": "Search Name or Mobile",
            "Payment": "Payment",
            "Date": "Date",
            "Name": "Name",
            "Mobile": "Mobile",
            "Payment type": "Payment type",
            "Doctor Name": "Doctor Name",
            "Net Amount": "Net Amount",
            "Amount Received": "Amount Received",
            "Outstanding Amount": "Outstanding Amount",
            "Action": "Action",
            "Received By": "Received By",
            "No Record found": "No Record found",
            "New Bill": "New Bill",
            "Billing History": "Billing History",
            "Datewise Billing": "Datewise Billing",
            "Total": "Total",
            "Checkup Reports": "Checkup Reports",
            "Sr No": "Sr No",
            "Patient Id": "Patient Id",
            "Appointment": "Appointment",
            "Doctor": "Doctor",
            "Bill": "Bill",
            "Select Size": "Select Size",
            "Orientation": "Orientation",
            "Portrait": "Portrait",
            "Landscape": "Landscape",
            "PREVIEW": "PREVIEW",
            "PRINT": "PRINT",
            "Format": "Format",
            "PDF Format": "PDF Format",
            "Excel Format": "Excel Format",
            "EXPORT": "EXPORT",
            "EXPORTING...": "EXPORTING...",
            "CLOSE PREVIEW": "CLOSE PREVIEW",
            "CHECKUP REPORT PREVIEW": "CHECKUP REPORT PREVIEW",
            "Waiting List Report": "Waiting List Report",
            "CheckUp Report": "CheckUp Report",
            "Certificate Report": "Certificate Report",
            "Waiting Id": "Waiting Id",
            "Today's Waiting List Report": "Today's Waiting List Report",
            "WAITING LIST REPORT PREVIEW": "WAITING LIST REPORT PREVIEW",
            "Appointments scheduled": "Appointments scheduled",
            "Patients waiting in the queue": "Patients waiting in the queue",
            "What's happening today:": "What's happening today:",
            "Daily Overview": "Daily Overview",
            "Completed Today": "Completed Today",
            "In Queue": "In Queue",
            "All Time Records": "All Time Records",
            "Pharmacy Inventory": "Pharmacy Inventory",
            "Active Staff": "Active Staff",
            "Active IPD Cases": "Active IPD Cases",
            "Checked Patients": "Checked Patients",
            "Remaining Patients": "Remaining Patients",
            "Total Patients": "Total Patients",
            "Total Medicines": "Total Medicines",
            "Total Users": "Total Users",
            "IPD Patients": "IPD Patients",
            "Welcome": "Welcome",
            "Search Patient": "Search Patient",
            "Book Appointment:": "Book Appointment:",
            "Schedule Appointment": "Schedule Appointment",
            "Waiting List": "Waiting List",
            "Take Vitals": "Take Vitals",
            "Send to Doctor": "Send to Doctor",
            "Examination": "Examination",
            "Weight (kg)": "Weight (kg)",
            "BP Systolic": "BP Systolic",
            "BP Diastolic": "BP Diastolic",
            "Pulse (bpm)": "Pulse (bpm)",
            "Temp (°F)": "Temp (°F)",
            "SpO2 (%)": "SpO2 (%)",
            "Send Inside": "Send Inside",
            "Back": "Back",
            "Today's Patients": "Today's Patients",
            "Ready": "Ready",
            "Check Up": "Check Up",
            "Search by Name or Mobile...": "Search by Name or Mobile...",
            "Register Patient": "Register Patient",
            "Personal Information": "Personal Information",
            "First Name": "First Name",
            "Middle Name": "Middle Name",
            "Last Name": "Last Name",
            "Nick Name": "Nick Name",
            "Gender": "Gender",
            "Date of Birth": "Date of Birth",
            "Age (Years)": "Age (Years)",
            "Marital Status": "Marital Status",
            "Identity & Background": "Identity & Background",
            "Religion": "Religion",
            "Caste": "Caste",
            "Occupation": "Occupation",
            "Pan Card No": "Pan Card No",
            "Aadhar Card No": "Aadhar Card No",
            "Identification Mark": "Identification Mark",
            "Contact Information": "Contact Information",
            "Mobile Number": "Mobile Number",
            "Alt Mobile No": "Alt Mobile No",
            "Email": "Email",
            "Address & Reference": "Address & Reference",
            "Address": "Address",
            "City": "City",
            "Pincode": "Pincode",
            "Referred By": "Referred By",
            "Registration No": "Registration No",
            "Reg No": "Reg No",
            "Male": "Male",
            "Female": "Female",
            "Other": "Other",
            "Single": "Single",
            "Married": "Married",
            "Divorced": "Divorced",
            "Widowed": "Widowed",
            "Cancel": "Cancel",
            "Submitting...": "Submitting...",
            "Today's Appointments": "Today's Appointments",
            "Search": "Search",
            "New Patient": "New Patient",
            "You have": "You have",
            "scheduled and": "scheduled and",
            "Appointments": "Appointments",
            "Patients": "Patients",
            "waiting in the queue.": "waiting in the queue.",
            "Patient": "Patient",
            "Billing": "Billing",
            "Reports": "Reports",
            "Config": "Config",
            "NEW PATIENT": "NEW PATIENT",
            "Patient Name": "Patient Name",
            "No patients found. Search to add to waiting list.": "No patients found. Search to add to waiting list.",
            "Select": "Select",
            "Date:": "Date:",
            "Search:": "Search:",
            "Enter Name...": "Enter Name...",
            "Sr. No.": "Sr. No.",
            "Actions": "Actions",
            "Todays Patients": "Todays Patients",
            "Weight": "Weight",
            "BP (Sys/Dys)": "BP (Sys/Dys)",
            "Temp": "Temp",
            "Pulse": "Pulse",
            "Status": "Status",
            "No Patients in the waiting list today.": "No Patients in the waiting list today.",
            "Waiting": "Waiting",
            "Save Bill": "Save Bill",
            "Save Prescription": "Save Prescription",
            "Total Amount:": "Total Amount:",
            "Amount Received:": "Amount Received:",
            "Outstanding Amount:": "Outstanding Amount:",
            "Submit": "Submit",
            "Export": "Export",
            "WhatsApp": "WhatsApp",
            "All Doctors": "All Doctors",
            "Are you sure you want to register this patient?": "Are you sure you want to register this patient?",
            "Patient already exists in the system.": "Patient already exists in the system.",
            "Y": "Y",
            "M": "M",
            "D": "D",
            "O.A": "O.A",
            "Edit Patient": "Edit Patient",
            "bpSystolic": "BP Systolic",
            "bpDiastolic": "BP Diastolic",
            "Diagnosis": "Diagnosis",
            "Enter Diagnosis": "Enter Diagnosis",
            "Complaint": "Complaint",
            "Advice": "Advice",
            "Please enter prescription name": "Please enter prescription name",
            "Required": "Required",
            "No Prescription Found...": "No Prescription Found...",
            "Available Prescriptions": "Available Prescriptions",
            "Breakfast": "Breakfast",
            "Lunch": "Lunch",
            "Dinner": "Dinner",
            "Before": "Before",
            "After": "After",
            "Type": "Type",
            "Medicine": "Medicine",
            "Dosage": "Dosage",
            "Search Medicine...": "Search Medicine...",
            "Instructions": "Instructions",
            "Days": "Days",
            "Add Medicine": "Add Medicine",
            "Sr.No.": "Sr.No.",
            "No medicines prescribed": "No medicines prescribed",
            "Are you sure you want to clear all added medicines?": "Are you sure you want to clear all added medicines?",
            "Clear All": "Clear All",
            "Instr": "Instr",
            "Save": "Save",
            "Clear": "Clear",
            "Bill amount is required": "Bill amount is required",
            "Validation Error": "Validation Error",
            "Checkup Done...": "Checkup Done...",
            "Prescribed Medicines:": "Prescribed Medicines:",
            "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}": "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}",
            "the hospital": "the hospital",
            "Allergy": "Allergy",
            "SpO2": "SpO2",
            "SN": "SN",
            "ID": "ID",
            "Move Up": "Move Up",
            "Move Down": "Move Down",
            "Delete": "Delete",
            "Delete Patient": "Delete Patient",
            "Are you sure you want to remove {{name}} from the waiting list?": "Are you sure you want to remove {{name}} from the waiting list?",
            "Patient {{name}} removed from waiting list.": "Patient {{name}} removed from waiting list.",
            "Please select a date": "Please select a date",
            "Unable to load date-wise data": "Unable to load date-wise data",
            "Waiting list has only one patient. Cannot move up or down.": "Waiting list has only one patient. Cannot move up or down.",
            "Waiting number changed": "Waiting number changed",
            "Waiting number not get updated": "Waiting number not get updated",
            "Patient added to waiting list successfully!": "Patient added to waiting list successfully!",
            "There has been a problem with your fetch operation": "There has been a problem with your fetch operation",
            "No patient records found.": "No patient records found.",
            "View Details": "View Details",
            "Loading...": "Loading...",
            "Deleting...": "Deleting...",
            "Back to List": "Back to List",
            "Are you sure you want to delete {{name}}? This action cannot be undone.": "Are you sure you want to delete {{name}}? This action cannot be undone.",
            "Could not delete patient": "Could not delete patient",
            "Patient deleted successfully!": "Patient deleted successfully!",
            "Patient Information": "Patient Information",
            "Hospital Name": "Hospital Name",
            "Registration No.": "Registration No.",
            "Email Address": "Email Address",
            "Website": "Website",
            "Phone Number": "Phone Number",
            "Alt Phone Number": "Alt Phone Number",
            "Speciality": "Speciality",
            "Tahsil": "Tahsil",
            "District": "District",
            "State": "State",
            "Country": "Country",
            "Full Address": "Full Address",
            "Brief description...": "Brief description...",
            "Description": "Description",
            "CheckUp Save Bill": "CheckUp Save Bill",
            "Print Certificate": "Print Certificate",
            "OPD Print Bill": "OPD Print Bill",
            "Print Prescription Header": "Print Prescription Header",
            "Print Prescription Footer": "Print Prescription Footer",
            "OPD Print Prescription": "OPD Print Prescription",
            "IPD Print Prescription": "IPD Print Prescription",
            "IPD Print Bill": "IPD Print Bill",
            "IPD Access": "IPD Access",
            "Opd Fee": "Opd Fee",
            "Prescription Footer": "Prescription Footer",
            "Set Prescription Header": "Set Prescription Header",
            "Prescription Language": "Prescription Language",
            "Select Prescription Design": "Select Prescription Design",
            "Select Header Template": "Select Header Template",
            "Header Template 1": "Header Template 1",
            "Header Template 2": "Header Template 2",
            "Header Template 3": "Header Template 3",
            "Header Template 4": "Header Template 4",
            "Preview Full Design": "Preview Full Design",
            "Preview Header": "Preview Header",
            "Application Theme Colour": "Application Theme Colour",
            "Teal (Premium)": "Teal (Premium)",
            "Classic Blue": "Classic Blue",
            "Natural Green": "Natural Green",
            "Bold Red": "Bold Red",
            "Royal Purple": "Royal Purple",
            "Vibrant Indigo": "Vibrant Indigo",
            "Warm Orange": "Warm Orange",
            "Professional Navy": "Professional Navy",
            "Saving...": "Saving...",
            "Loading settings...": "Loading settings...",
            "Effective Date": "Effective Date",
            "Last Updated": "Last Updated",
            "Introduction": "Introduction",
            "Our Roles Under the DPDP Act": "Our Roles Under the DPDP Act",
            "How We Store & Secure Data": "How We Store & Secure Data",
            "Data Retention and Deletion": "Data Retention and Deletion",
            "Your Rights (Data Principal)": "Your Rights (Data Principal)",
            "Disclosure to Third Parties": "Disclosure to Third Parties",
            "Grievance Redressal": "Grievance Redressal",
            "Welcome to Dr Tech Buddy, a Hospital Management System developed and operated by Invensoft Solutions. We are committed to protecting the privacy and security of the data processed through our platform.": "Welcome to Dr Tech Buddy, a Hospital Management System developed and operated by Invensoft Solutions. We are committed to protecting the privacy and security of the data processed through our platform.",
            "This policy outlines how we handle personal data in compliance with India’s Digital Personal Data Protection (DPDP) Act, 2023 and the DPDP Rules, 2025.": "This policy outlines how we handle personal data in compliance with India’s Digital Personal Data Protection (DPDP) Act, 2023 and the DPDP Rules, 2025.",
            "To ensure clarity on legal liability, we distinguish between two types of data:": "To ensure clarity on legal liability, we distinguish between two types of data:",
            "Client Data": "Client Data",
            "Patient Data": "Patient Data",
            "You are the Data Fiduciary": "You are the Data Fiduciary",
            "You are the Data Processor": "You are the Data Processor",
            "Collected": "Collected",
            "Processed": "Processed",
            "Account management, billing, and technical support.": "Account management, billing, and technical support.",
            "Patient names, health records, medical history, and treatments.": "Patient names, health records, medical history, and treatments.",
            "Purpose": "Purpose",
            "Responsibility": "Responsibility",
            "The Hospital is solely responsible for getting patient consent.": "The Hospital is solely responsible for getting patient consent.",
            "We employ a 3 tier architecture with strict data isolation to ensure maximum security.": "We employ a 3 tier architecture with strict data isolation to ensure maximum security.",
            "Database Isolation": "Database Isolation",
            "Server Location": "Server Location",
            "Encryption": "Encryption",
            "Access Control": "Access Control",
            "Every hospital is assigned a separate, isolated database.": "Every hospital is assigned a separate, isolated database.",
            "All data is hosted on secure Cloud Platform, located within India. We do not transfer health data across borders.": "All data is hosted on secure Cloud Platform, located within India. We do not transfer health data across borders.",
            "Data is encrypted in transit (SSL/TLS) and at rest where applicable.": "Data is encrypted in transit (SSL/TLS) and at rest where applicable.",
            "Only authorized personnel with valid credentials can access the system. We maintain logs of all access for security audits.": "Only authorized personnel with valid credentials can access the system. We maintain logs of all access for security audits.",
            "Retained as long as subscription is active and per Indian tax laws (financial records).": "Retained as long as subscription is active and per Indian tax laws (financial records).",
            "Retained only during subscription. Upon termination:": "Retained only during subscription. Upon termination:",
            "We provide a full downloadable export of the Hospital's data.": "We provide a full downloadable export of the Hospital's data.",
            "We permanently delete the Hospital’s separate database from our Cloud within 60 days of contract termination.": "We permanently delete the Hospital’s separate database from our Cloud within 60 days of contract termination.",
            "Access the personal data we hold about you (e.g., your profile).": "Access the personal data we hold about you (e.g., your profile).",
            "Request correction of inaccurate details.": "Request correction of inaccurate details.",
            "Withdraw consent for marketing communications.": "Withdraw consent for marketing communications.",
            "Register a grievance regarding your data privacy.": "Register a grievance regarding your data privacy.",
            "Note: Patients seeking to exercise rights regarding medical records must contact their respective Hospital directly.": "Note: Patients seeking to exercise rights regarding medical records must contact their respective Hospital directly.",
            "We do not sell or trade personal data. We may share data only with Legal Authorities if required by Indian law or a court order.": "We do not sell or trade personal data. We may share data only with Legal Authorities if required by Indian law or a court order.",
            "If you have any questions or grievances, contact our Data Protection Officer (DPO):": "If you have any questions or grievances, contact our Data Protection Officer (DPO):",
            "Chat on WhatsApp": "Chat on WhatsApp",
            "Call Us": "Call Us",
            "Email Us": "Email Us",
            "Certificate Management": "Certificate Management",
            "Prescription Management": "Prescription Management",
            "Certificate Name": "Certificate Name",
            "Certificate Content": "Certificate Content",
            "Saved Certificates": "Saved Certificates",
            "Add New Certificate": "Add New Certificate",
            "Update Certificate": "Update Certificate",
            "Enter certificate name (e.g., Medical Certificate, Fitness Certificate)": "Enter certificate name (e.g., Medical Certificate, Fitness Certificate)",
            "Write certificate content here...": "Write certificate content here...",
            "Are you sure you want to delete this certificate?": "Are you sure you want to delete this certificate?",
            "No certificates found": "No certificates found",
            "Prescription Templates": "Prescription Templates",
            "Create Prescription Template": "Create Prescription Template",
            "Update Prescription Template": "Update Prescription Template",
            "Update Template": "Update Template",
            "Add Template": "Add Template",
            "Special instructions...": "Special instructions...",
            "No templates found": "No templates found",
            "Are you sure you want to delete this template?": "Are you sure you want to delete this template?",
            "Clear Info": "Clear Info",
            "Update Prescription": "Update Prescription",
            "Saved Prescriptions": "Saved Prescriptions",
            "No prescriptions found": "No prescriptions found",
            "View": "View",
            "Enter Diagnosis...": "Enter Diagnosis...",
            "Are you sure you want to delete this prescription?": "Are you sure you want to delete this prescription?",
            "Clear All Medicines": "Clear All Medicines",
            "Delete Prescription": "Delete Prescription",
            "Are you sure you want to clear all added medicines?": "Are you sure you want to clear all added medicines?",
            "Search Patient...": "Search Patient...",
            "Sent to Doctor": "Sent to Doctor",
            "Confirm": "Confirm",
            "This action cannot be undone.": "This action cannot be undone.",
            "Temperature": "Temperature",
            "SpO2": "SpO2",
            "Medical History": "Medical History",
            "Full History": "Full History",
            "Get Certificate": "Get Certificate",
            "B/L/D": "B/L/D",
            "Medicine": "Medicine",
            "Type": "Type",
            "Dosage": "Dosage",
            "Breakfast": "Breakfast",
            "Lunch": "Lunch",
            "Dinner": "Dinner",
            "Days": "Days",
            "Instr": "Instr",
            "Medicine Name": "Medicine Name",
            "Instruction": "Instruction",
            "Diagnosis": "Diagnosis",
            "Allergy": "Allergy",
            "Complaint": "Complaint",
            "Advice": "Advice",
            "Select": "Select",
            "Print": "Print",
            "PDF": "PDF",
            "Meds": "Meds",
            "Get Your Certificate": "Get Your Certificate",
            "Patient Name:": "Patient Name:",
            "Certificate Type:": "Certificate Type:",
            "Select Certificate": "Select Certificate",
            "Save Certificate": "Save Certificate",
            "Certificate Preview": "Certificate Preview",
            "Close Preview": "Close Preview",
            "Download PDF": "Download PDF",
            "Export PDF": "Export PDF",
            "Reg. No:": "Reg. No:",
            "Address:": "Address:",
            "Mobile:": "Mobile:",
            "Weight": "Weight",
            "BP (Sys)": "BP (Sys)",
            "BP (Dia)": "BP (Dia)",
            "Pulse": "Pulse",
            "Temp": "Temp",
            "Close": "Close",
            "Preview & Print": "Preview & Print",
            "Total Amount:": "Total Amount:",
            "Amount Received:": "Amount Received:",
            "Outstanding Amount:": "Outstanding Amount:",
            "Save Bill": "Save Bill",
            "Save Prescription": "Save Prescription",
            "Submit": "Submit",
            "Submitting...": "Submitting...",
            "Export": "Export",
            "WhatsApp": "WhatsApp",
            "Back": "Back",
            "Y": "Y",
            "M": "M",
            "D": "D",
            "Edit Patient": "Edit Patient",
            "O.A": "O.A",
            "Date": "Date",
            "Enter Diagnosis": "Enter Diagnosis",
            "Clear": "Clear",
            "Add Medicine": "Add Medicine",
            "Clear All": "Clear All",
            "No medicines prescribed": "No medicines prescribed",
            "Before": "Before",
            "After": "After",
            "BEFORE": "BEFORE",
            "AFTER": "AFTER",
            "Date:": "Date:",
            "Search:": "Search:",
            "Doctor:": "Doctor:",
            "Enter Name...": "Enter Name...",
            "All Doctors": "All Doctors",
            "Sr. No.": "Sr. No.",
            "Actions": "Actions",
            "Send to Doctor": "Send to Doctor",
            "Already sent to doctor": "Already sent to doctor",
            "Sr.No.": "Sr.No.",
            "Name:": "Name:",
            "Authorized Signatory": "Authorized Signatory",
            "Addr:": "Addr:",
            "bpSystolic": "BP Systolic",
            "bpDiastolic": "BP Diastolic",
            "Move Up": "Move Up",
            "Move Down": "Move Down",
            "Search Medicine...": "Search Medicine...",
            "Instructions": "Instructions",
            "Prescribed Medicines:": "Prescribed Medicines:",
            "the hospital": "the hospital",
            "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}": "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}",
            "Validation Error": "Validation Error",
            "Bill amount is required": "Bill amount is required",
            "Prescription not submitted, please add medicines...": "Prescription not submitted, please add medicines...",
            "Checkup Done...": "Checkup Done...",
            "Patient data submitted successfully.": "Patient data submitted successfully.",
            "BP (Sys/Dys)": "BP (Sys/Dys)",
            "Search by Name or Mobile...": "Search by Name or Mobile...",
            "Checkup": "Checkup",
            "Patient could not be deleted": "Patient could not be deleted",
            "Could not fetch patient details. Please try again.": "Could not fetch patient details. Please try again.",
            "refresh patient list": "refresh patient list",
            "Select Patient": "Select Patient",
            "Save Details": "Save Details",
            "This patient is already available in today's checkup list!": "This patient is already available in today's checkup list!",
            "Could not {{action}} patient": "Could not {{action}} patient",
            "Patient {{action}} successfully!": "Patient {{action}} successfully!",
            "added": "added",
            "updated": "updated",
            "save": "save",
            "update": "update",
            "update": "update",
            "B/L/D": "B/L/D",
            "Sr No": "Sr No",
            "User Information": "User Information",
            "User-Id": "User-Id",
            "User Name": "User Name",
            "Role": "Role",
            "No user records found.": "No user records found.",
            "Search User by Name...": "Search User by Name...",
            "New User": "New User",
            "Medicine Information": "Medicine Information",
            "Medicine-Id": "Medicine-Id",
            "Manufacturer": "Manufacturer",
            "Manufacturer Name": "Manufacturer Name",
            "Price": "Price",
            "Barcode": "Barcode",
            "Expiry": "Expiry",
            "No medicine records found.": "No medicine records found.",
            "Search Medicine by Name...": "Search Medicine by Name...",
            "New Medicine": "New Medicine",
            "Edit Medicine Details": "Edit Medicine Details",
            "Medicine ID": "Medicine ID",
            "Medicine Name": "Medicine Name",
            "Medicine Type": "Medicine Type",
            "Disease": "Disease",
            "Expiry Date": "Expiry Date",
            "Save Changes": "Save Changes",
            "Search Patient": "Search Patient",
            "Enter Name or Mobile": "Enter Name or Mobile",
            "Patient Prescription": "Patient Prescription",
            "Date & Time": "Date & Time",
            "This action cannot be undone.": "This action cannot be undone.",
            "Confirm": "Confirm",
            "Select Size": "Select Size",
            "Orientation": "Orientation",
            "Format": "Format",
            "Portrait": "Portrait",
            "Landscape": "Landscape",
            "PDF Format": "PDF Format",
            "Image Format": "Image Format",
            "PREVIEW": "PREVIEW",
            "PRINT": "PRINT",
            "Medicine Basic Info": "Medicine Basic Info",
            "Manufacturing & Pricing": "Manufacturing & Pricing",
            "Inventory Details": "Inventory Details",
            "Search Patients": "Search Patients",
            "IPD Settings": "IPD Settings",
            "IPD Patient Admission": "IPD Patient Admission",
            "Search Existing patient by Name or Mobile": "Search Existing patient by Name or Mobile",
            "ADD NEW PATIENT": "ADD NEW PATIENT",
            "Remarks / Additional Notes (Please specify reason for Transfer/Cancellation if applicable)": "Remarks / Additional Notes (Please specify reason for Transfer/Cancellation if applicable)",
            "Bed Availability": "Bed Availability",
            "Filter by Floor": "Filter by Floor",
            "Search or Select Floor": "Search or Select Floor",
            "Filter by Ward": "Filter by Ward",
            "Search or Select Ward": "Search or Select Ward",
            "Filter by Bed No": "Filter by Bed No",
            "Search bed number...": "Search bed number...",
            "Filter by Status": "Filter by Status",
            "Available": "Available",
            "Occupied": "Occupied",
            "Ward Name": "Ward Name",
            "Bed No": "Bed No",
            "Bed Number": "Bed Number",
            "Description": "Description",
            "Actions": "Actions",
            "Loading availability...": "Loading availability...",
            "No matching available beds found": "No matching available beds found",
            "IPD Hospital Configuration": "IPD Hospital Configuration",
            "Update Details": "Update Details",
            "Add Details": "Add Details",
            "Floor Name": "Floor Name",
            "Ward / Room": "Ward / Room",
            "Enter No": "Enter No",
            "Configured Wards & Beds": "Configured Wards & Beds",
            "No configurations found.": "No configurations found."
        }
    },
    MARATHI: {
        translation: {
            "Dashboard": "डॅशबोर्ड",
            "APPOINTMENT": "अपॉइंटमेंट",
            "CHECKUP LIST": "चेकअप लिस्ट",
            "PATIENTS": "रुग्ण",
            "IPD": "आय.पी.डी.",
            "STAFF": "स्टाफ",
            "PHARMACY": "फार्मसी",
            "OPD BILLING": "ओ.पी.डी. बिलिंग",
            "OPD REPORTS": "ओ.पी.डी. रिपोर्ट्स",
            "CONFIG": "सेटिंग",
            "LOGOUT": "लॉगआउट",
            "Hospital Information": "हॉस्पिटल माहिती",
            "System Configuration": "सिस्टम कॉन्फिगरेशन",
            "Privacy Policy": "प्रायव्हसी पॉलिसी",
            "Application Language": "ॲप्लिकेशन भाषा",
            "Save System Config": "सेटिंग सेव्ह करा",
            "Save Hospital Info": "माहिती सेव्ह करा",
            "Billing Statements": "बिलिंग स्टेटमेंट्स",
            "Start Date": "प्रारंभ तारीख",
            "End Date": "अंतिम तारीख",
            "SUBMIT": "सबमिट",
            "CLEAR": "क्लियर",
            "Outstanding Only": "फक्त थकबाकी",
            "Search Name or Mobile": "नाव किंवा मोबाईल शोधा",
            "Payment": "पेमेंट",
            "Date": "तारीख",
            "Name": "नाव",
            "Mobile": "मोबाईल",
            "Payment type": "पेमेंट प्रकार",
            "Doctor Name": "डॉक्टरांचे नाव",
            "Net Amount": "एकूण रक्कम",
            "Amount Received": "प्राप्त रक्कम",
            "Outstanding Amount": "थकबाकी रक्कम",
            "Action": "कृती",
            "Received By": "यांनी प्राप्त केले",
            "No Record found": "कोणताही रेकॉर्ड सापडला नाही",
            "New Bill": "नवीन बिल",
            "Billing History": "बिलिंग इतिहास",
            "Datewise Billing": "तारीखनुसार बिलिंग",
            "Total": "एकूण",
            "Checkup Reports": "चेकअप रिपोर्ट",
            "Sr No": "अनुक्रमांक",
            "Patient Id": "रुग्ण आयडी",
            "Appointment": "अपॉइंटमेंट",
            "Doctor": "डॉक्टर",
            "Bill": "बिल",
            "Select Size": "आकार निवडा",
            "Orientation": "अभिमुखता",
            "Portrait": "पोर्ट्रेट",
            "Landscape": "लँडस्केप",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Format": "स्वरूप",
            "PDF Format": "PDF स्वरूप",
            "Excel Format": "Excel स्वरूप",
            "EXPORT": "एक्सपोर्ट",
            "EXPORTING...": "एक्सपोर्ट होत आहे...",
            "CLOSE PREVIEW": "पूर्वावलोकन बंद करा",
            "CHECKUP REPORT PREVIEW": "चेकअप रिपोर्ट पूर्वावलोकन",
            "Waiting List Report": "प्रतीक्षा यादी रिपोर्ट",
            "CheckUp Report": "चेकअप रिपोर्ट",
            "Certificate Report": "प्रमाणपत्र रिपोर्ट",
            "Waiting Id": "प्रतीक्षा आयडी",
            "Today's Waiting List Report": "आजची प्रतीक्षा यादी रिपोर्ट",
            "WAITING LIST REPORT PREVIEW": "प्रतीक्षा यादी रिपोर्ट पूर्वावलोकन",
            "Appointments scheduled": "अपॉइंटमेंट शेड्यूल केल्या आहेत",
            "Patients waiting in the queue": "रुग्ण रांगेत वाट पाहत आहेत",
            "What's happening today:": "आज काय घडत आहे:",
            "Daily Overview": "दैनिक विहंगावलोकन",
            "Completed Today": "आज पूर्ण झाले",
            "In Queue": "रांगेत",
            "All Time Records": "सर्ववेळचे रेकॉर्ड",
            "Pharmacy Inventory": "फार्मसी इन्व्हेंटरी",
            "Active Staff": "सक्रिय कर्मचारी",
            "Active IPD Cases": "सक्रिय आय.पी.डी. केसेस",
            "Checked Patients": "तपासलेले रुग्ण",
            "Remaining Patients": "उर्वरित रुग्ण",
            "Total Patients": "एकूण रुग्ण",
            "Total Medicines": "एकूण औषधे",
            "Total Users": "एकूण वापरकर्ते",
            "IPD Patients": "आय.पी.डी. रुग्ण",
            "Welcome": "स्वागत आहे",
            "Search Patient": "रुग्ण शोधा",
            "Book Appointment:": "अपॉइंटमेंट बुक करा:",
            "Schedule Appointment": "अपॉइंटमेंट शेड्यूल करा",
            "Waiting List": "प्रतीक्षा यादी",
            "Take Vitals": "वाइटल्स घ्या",
            "Send to Doctor": "डॉक्टरांकडे पाठवा",
            "Examination": "तपासणी",
            "Weight (kg)": "वजन (किग्रॅ)",
            "BP Systolic": "बीपी सिस्टोलिक",
            "BP Diastolic": "बीपी डायस्टोलिक",
            "Pulse (bpm)": "पल्स (बीपीएम)",
            "Temp (°F)": "तापमान (°फॅ)",
            "SpO2 (%)": "SpO2 (%)",
            "Send Inside": "आत पाठवा",
            "Back": "मागे",
            "Today's Patients": "आजचे रुग्ण",
            "Ready": "तयार",
            "Check Up": "चेक अप",
            "Search by Name or Mobile...": "नाव किंवा मोबाईलने शोधा...",
            "Register Patient": "रुग्णाची नोंदणी करा",
            "Personal Information": "वैयक्तिक माहिती",
            "First Name": "नाव",
            "Middle Name": "मधले नाव",
            "Last Name": "आडनाव",
            "Nick Name": "टोपण नाव",
            "Gender": "लिंग",
            "Date of Birth": "जन्मतारीख",
            "Age (Years)": "वय (वर्षे)",
            "Marital Status": "वैवाहिक स्थिती",
            "Identity & Background": "ओळख आणि पार्श्वभूमी",
            "Religion": "धर्म",
            "Caste": "जात",
            "Occupation": "व्यवसाय",
            "Pan Card No": "पॅन कार्ड नंबर",
            "Aadhar Card No": "आधार कार्ड नंबर",
            "Identification Mark": "ओळख खून",
            "Contact Information": "संपर्क माहिती",
            "Mobile Number": "मोबाईल नंबर",
            "Alt Mobile No": "पर्यायी मोबाईल नंबर",
            "Email": "ईमेल",
            "Address & Reference": "पत्ता आणि संदर्भ",
            "Address": "पत्ता",
            "City": "शहर",
            "Pincode": "पिनकोड",
            "Referred By": "यांनी संदर्भित",
            "Registration No": "नोंदणी क्रमांक",
            "Reg No": "नोंदणी क्र.",
            "Male": "पुरुष",
            "Female": "महिला",
            "Other": "इतर",
            "Single": "अविवाहित",
            "Married": "विवाहित",
            "Divorced": "घटस्फोटित",
            "Widowed": "विधवा/विधुर",
            "Cancel": "रद्द करा",
            "Submitting...": "सबमिट होत आहे...",
            "Today's Appointments": "आजच्या अपॉइंटमेंट",
            "Search": "शोधा",
            "New Patient": "नवीन रुग्ण",
            "You have": "तुमच्याकडे",
            "scheduled and": "शेड्यूल आहेत आणि",
            "Appointments": "अपॉइंटमेंट",
            "Patients": "रुग्ण",
            "waiting in the queue.": "रांगेत वाट पाहत आहेत.",
            "Patient": "रुग्ण",
            "Billing": "बिलिंग",
            "Reports": "रिपोर्ट्स",
            "Config": "सेटिंग",
            "NEW PATIENT": "नवीन रुग्ण",
            "Patient Name": "रुग्णाचे नाव",
            "No patients found. Search to add to waiting list.": "रुग्ण सापडले नाहीत. प्रतीक्षा यादीत समाविष्ट करण्यासाठी शोधा.",
            "Select": "निवडा",
            "Date:": "तारीख:",
            "Search:": "शोधा:",
            "Enter Name...": "नाव प्रविष्ट करा...",
            "Sr. No.": "अनुक्रमांक",
            "Actions": "कृती",
            "Todays Patients": "आजचे रुग्ण",
            "Weight": "वजन",
            "BP (Sys/Dys)": "बीपी (सिस्टोलिक/डायस्टोलिक)",
            "Temp": "तापमान",
            "Pulse": "पल्स",
            "Status": "स्थिती",
            "No Patients in the waiting list today.": "आज प्रतीक्षा यादीत एकही रुग्ण नाही.",
            "Waiting": "प्रतीक्षा करत आहे",
            "Save Bill": "बिल सेव्ह करा",
            "Save Prescription": "प्रिस्क्रिप्शन सेव्ह करा",
            "Total Amount:": "एकूण रक्कम:",
            "Amount Received:": "प्राप्त रक्कम:",
            "Outstanding Amount:": "थकबाकी रक्कम:",
            "Submit": "सबमिट",
            "Export": "एक्सपोर्ट",
            "WhatsApp": "व्हॉट्सॲप",
            "All Doctors": "सर्व डॉक्टर",
            "Are you sure you want to register this patient?": "तुम्हाला खात्री आहे की तुम्ही या रुग्णाची नोंदणी करू इच्छिता?",
            "Patient already exists in the system.": "रुग्ण आधीच सिस्टममध्ये अस्तित्वात आहे.",
            "Y": "व",
            "M": "म",
            "D": "दि",
            "O.A": "थकबाकी",
            "Edit Patient": "रुग्ण माहिती बदला",
            "bpSystolic": "बीपी सिस्टोलिक",
            "bpDiastolic": "बीपी डायस्टोलिक",
            "Diagnosis": "निदान",
            "Enter Diagnosis": "निदान प्रविष्ट करा",
            "Complaint": "तक्रार",
            "Advice": "सल्ला",
            "Please enter prescription name": "कृपया प्रिस्क्रिप्शन नाव प्रविष्ट करा",
            "Required": "आवश्यक",
            "No Prescription Found...": "प्रिस्क्रिप्शन सापडले नाही...",
            "Available Prescriptions": "उपलब्ध प्रिस्क्रिप्शन",
            "Breakfast": "न्याहारी",
            "Lunch": "दुपारचे जेवण",
            "Dinner": "रात्रीचे जेवण",
            "Before": "आधी",
            "After": "नंतर",
            "Type": "प्रकार",
            "Medicine": "औषध",
            "Dosage": " डोस",
            "Search Medicine...": "औषध शोधा...",
            "Instructions": "सूचना",
            "Days": "दिवस",
            "Add Medicine": "औषध जोडा",
            "Sr.No.": "अनुक्रमांक",
            "No medicines prescribed": "कोणतीही औषधे लिहून दिलेली नाहीत",
            "Are you sure you want to clear all added medicines?": "तुम्हाला खात्री आहे की तुम्ही सर्व जोडलेली औषधे पुसून टाकू इच्छिता?",
            "Clear All": "सर्व पुसून टाका",
            "Instr": "सूचना",
            "Save": "सेव्ह करा",
            "Clear": "पुसून टाका",
            "Bill amount is required": "बिलाची रक्कम आवश्यक आहे",
            "Validation Error": "व्हॅलिडेशन एरर",
            "Checkup Done...": "चेकअप पूर्ण झाले...",
            "Prescribed Medicines": "लिहून दिलेली औषधे",
            "Prescribed Medicines:": "लिहून दिलेली औषधे:",
            "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}": "नमस्कार {{patientName}}, {{hospitalName}} कडून तुमचे प्रिस्क्रिप्शन तयार आहे.{{medicineText}}\n\nशुभेच्छा,\n{{hospitalName}}",
            "the hospital": "हॉस्पिटल",
            "Allergy": "ॲलर्जी",
            "SpO2": "SpO2",
            "SN": "अनुक्रमांक",
            "ID": "आयडी",
            "Move Up": "वर हलवा",
            "Move Down": "खाली हलवा",
            "Delete": "काढून टाका",
            "Delete Patient": "रुग्ण काढून टाका",
            "Are you sure you want to remove {{name}} from the waiting list?": "तुम्हाला खात्री आहे का की तुम्ही {{name}} ला प्रतीक्षा यादीतून काढून टाकू इच्छिता?",
            "Patient {{name}} removed from waiting list.": "रुग्ण {{name}} ला प्रतीक्षा यादीतून काढून टाकले आहे.",
            "Please select a date": "कृपया तारीख निवडा",
            "Unable to load date-wise data": "तारीखनुसार डेटा लोड करण्यात अक्षम",
            "Waiting list has only one patient. Cannot move up or down.": "प्रतीक्षा यादीत फक्त एकच रुग्ण आहे. वर किंवा खाली हलवता येत नाही.",
            "Waiting number changed": "प्रतीक्षा क्रमांक बदलला",
            "Waiting number not get updated": "प्रतीक्षा क्रमांक अपडेट झाला नाही",
            "Patient added to waiting list successfully!": "रुग्ण प्रतीक्षा यादीत यशस्वीरित्या जोडला गेला!",
            "There has been a problem with your fetch operation": "तुमच्या फेच ऑपरेशनमध्ये समस्या आली आहे",
            "No patient records found.": "रुग्णाचे रेकॉर्ड सापडले नाहीत.",
            "View Details": "तपशील पहा",
            "Loading...": "लोड होत आहे...",
            "Deleting...": "डिलीट होत आहे...",
            "Back to List": "यादीत मागे जा",
            "Are you sure you want to delete {{name}}? This action cannot be undone.": "तुम्हाला खात्री आहे की तुम्ही {{name}} ला डिलीट करू इच्छिता? ही क्रिया पूर्ववत केली जाऊ शकत नाही.",
            "Could not delete patient": "रुग्ण डिलीट करता आला नाही",
            "Patient deleted successfully!": "रुग्ण यशस्वीरित्या डिलीट झाला!",
            "Patient Information": "रुग्ण माहिती",
            "Hospital Name": "हॉस्पिटलचे नाव",
            "Registration No.": "नोंदणी क्रमांक",
            "Email Address": "ईमेल पत्ता",
            "Website": "वेबसाईट",
            "Phone Number": "फोन नंबर",
            "Alt Phone Number": "पर्यायी फोन नंबर",
            "Speciality": "विशेषता",
            "Tahsil": "तहसील",
            "District": "जिल्हा",
            "State": "राज्य",
            "Country": "देश",
            "Full Address": "पूर्ण पत्ता",
            "Brief description...": "संक्षिप्त वर्णन...",
            "Description": "वर्णन",
            "CheckUp Save Bill": "चेकअप बिल सेव्ह करा",
            "Print Certificate": "सर्टिफिकेट प्रिंट करा",
            "OPD Print Bill": "ओपीडी बिल प्रिंट करा",
            "Print Prescription Header": "प्रिस्क्रिप्शन हेडर प्रिंट करा",
            "Print Prescription Footer": "प्रिस्क्रिप्शन फुटर प्रिंट करा",
            "OPD Print Prescription": "ओपीडी प्रिस्क्रिप्शन प्रिंट करा",
            "IPD Print Prescription": "आयपीडी प्रिस्क्रिप्शन प्रिंट करा",
            "IPD Print Bill": "आयपीडी बिल प्रिंट करा",
            "IPD Access": "आयपीडी ॲक्सेस",
            "Opd Fee": "ओपीडी फी",
            "Prescription Footer": "प्रिस्क्रिप्शन फुटर",
            "Set Prescription Header": "प्रिस्क्रिप्शन हेडर सेट करा",
            "Prescription Language": "प्रिस्क्रिप्शन भाषा",
            "Select Prescription Design": "प्रिस्क्रिप्शन डिझाइन निवडा",
            "Select Header Template": "हेडर टेंप्लेट निवडा",
            "Header Template 1": "हेडर टेंप्लेट १",
            "Header Template 2": "हेडर टेंप्लेट २",
            "Header Template 3": "हेडर टेंप्लेट ३",
            "Header Template 4": "हेडर टेंप्लेट ४",
            "Preview Full Design": "पूर्ण डिझाइन पहा",
            "Preview Header": "हेडर पहा",
            "Application Theme Colour": "ॲप्लिकेशन थीम रंग",
            "Teal (Premium)": "टील (प्रीमियम)",
            "Classic Blue": "क्लासिक ब्लू",
            "Natural Green": "नॅचरल ग्रीन",
            "Bold Red": "बोल्ड रेड",
            "Royal Purple": "रॉयल पर्पल",
            "Vibrant Indigo": "व्हायब्रंट इंडिगो",
            "Warm Orange": "वार्म ऑरेंज",
            "Professional Navy": "प्रोफेशनल नेव्ही",
            "Saving...": "सेव्ह होत आहे...",
            "Loading settings...": "सेटिंग्ज लोड होत आहेत...",
            "Effective Date": "प्रभावी तारीख",
            "Last Updated": "शेवटचे अपडेट",
            "Introduction": "प्रस्तावना",
            "Our Roles Under the DPDP Act": "DPDP कायद्यांतर्गत आमची भूमिका",
            "How We Store & Secure Data": "आम्ही डेटा कसा स्टोअर आणि सुरक्षित करतो",
            "Data Retention and Deletion": "डेटा धारणा आणि हटवणे",
            "Your Rights (Data Principal)": "तुमचे अधिकार (डेटा प्रिन्सिपल)",
            "Disclosure to Third Parties": "तृतीय पक्षांना प्रकटीकरण",
            "Grievance Redressal": "तक्रार निवारण",
            "Welcome to Dr Tech Buddy, a Hospital Management System developed and operated by Invensoft Solutions. We are committed to protecting the privacy and security of the data processed through our platform.": "हॉस्पिटल मॅनेजमेंट सिस्टम, इनव्हेनसॉफ्ट सोल्यूशन्सद्वारे विकसित आणि ऑपरेट केलेल्या डॉ टेक बडीमध्ये आपले स्वागत आहे. आम्ही आमच्या प्लॅटफॉर्मद्वारे प्रक्रिया केलेल्या डेटाची गोपनीयता आणि सुरक्षा संरक्षित करण्यासाठी वचनबद्ध आहोत.",
            "This policy outlines how we handle personal data in compliance with India’s Digital Personal Data Protection (DPDP) Act, 2023 and the DPDP Rules, 2025.": "हे धोरण भारताच्या डिजिटल वैयक्तिक डेटा संरक्षण (DPDP) कायदा, २०२३ आणि DPDP नियम, २०२५ च्या पालनानुसार आम्ही वैयक्तिक डेटा कसा हाताळतो याचे वर्णन करते.",
            "To ensure clarity on legal liability, we distinguish between two types of data:": "कायदेशीर उत्तरदायित्वावर स्पष्टता सुनिश्चित करण्यासाठी, आम्ही दोन प्रकारच्या डेटामधील फरक ओळखतो:",
            "Client Data": "क्लायंट डेटा",
            "Patient Data": "रुग्ण डेटा",
            "You are the Data Fiduciary": "तुम्ही डेटा फिद्यूशरी आहात",
            "You are the Data Processor": "तुम्ही डेटा प्रोसेसर आहात",
            "Collected": "संकलित",
            "Processed": "प्रक्रिया केलेले",
            "Account management, billing, and technical support.": "खाते व्यवस्थापन, बिलिंग आणि तांत्रिक समर्थन.",
            "Patient names, health records, medical history, and treatments.": "रुग्णांची नावे, आरोग्य रेकॉर्ड, वैद्यकीय इतिहास आणि उपचार.",
            "Purpose": "उद्देश",
            "Responsibility": "जबाबदारी",
            "The Hospital is solely responsible for getting patient consent.": "रुग्णाची संमती घेण्यास हॉस्पिटल पूर्णपणे जबाबदार आहे.",
            "We employ a 3 tier architecture with strict data isolation to ensure maximum security.": "आम्ही जास्तीत जास्त सुरक्षा सुनिश्चित करण्यासाठी कडक डेटा अलगावसह ३ टायर आर्किटेक्चर वापरतो.",
            "Database Isolation": "डेटाबेस अलगाव",
            "Server Location": "सर्व्हर स्थान",
            "Encryption": "एनक्रिप्शन",
            "Access Control": "प्रवेश नियंत्रण",
            "Every hospital is assigned a separate, isolated database instance.": "प्रत्येक हॉस्पिटलला स्वतंत्र, वेगळे डेटाबेस इन्स्टन्स दिले जाते.",
            "All data is hosted on Virtual Private Servers (VPS) provided by Hostinger, located within India. We do not transfer health data across borders.": "सर्व डेटा होस्टिंगरद्वारे प्रदान केलेल्या व्हर्च्युअल प्रायव्हेट सर्व्हर्सवर (VPS) होस्ट केला जातो, जे भारतामध्ये स्थित आहेत. आम्ही आरोग्याचा डेटा सीमा ओलांडून हस्तांतरित करत नाही.",
            "Data is encrypted in transit (SSL/TLS) and at rest where applicable.": "डेटा ट्रान्झिटमध्ये (SSL/TLS) आणि जिथे लागू असेल तिथे रेस्टमध्ये एनक्रिप्ट केला जातो.",
            "Only authorized personnel with valid credentials can access the system. We maintain logs of all access for security audits.": "केवळ वैध क्रेडेन्शियल्स असलेले अधिकृत कर्मचारी सिस्टममध्ये प्रवेश करू शकतात. आम्ही सुरक्षा ऑडिटसाठी सर्व प्रवेशाचे लॉग राखून ठेवतो.",
            "Retained as long as subscription is active and per Indian tax laws (financial records).": "सबस्क्रिप्शन सक्रिय असेपर्यंत आणि भारतीय कर कायद्यांनुसार (आर्थिक रेकॉर्ड) राखून ठेवले जाईल.",
            "Retained only during subscription. Upon termination:": "केवळ सबस्क्रिप्शन दरम्यान राखून ठेवले जाईल. संपुष्टात आल्यावर:",
            "We provide a full downloadable export of the Hospital's data.": "आमी हॉस्पिटलच्या डेटाची संपूर्ण डाउनलोड करण्यायोग्य एक्सपोर्ट प्रदान करतो.",
            "We permanently delete the Hospital’s separate database from our VPS within 30 days of contract termination.": "आम्ही करार संपुष्टात आल्याच्या ३० दिवसांच्या आत आमच्या VPS मधून हॉस्पिटलचा स्वतंत्र डेटाबेस कायमचा डिलीट करतो.",
            "Access the personal data we hold about you (e.g., your profile).": "तुमच्याबद्दल आमच्याकडे असलेला वैयक्तिक डेटा ॲक्सेस करा (उदा. तुमचे प्रोफाइल).",
            "Request correction of inaccurate details.": "चुकीच्या तपशीलांच्या दुरुस्तीची विनंती करा.",
            "Withdraw consent for marketing communications.": "मार्केटिंग संप्रेषणांसाठी संमती मागे घ्या.",
            "Register a grievance regarding your data privacy.": "तुमच्या डेटा गोपनीयतेच्या संदर्भात तक्रार नोंदवा.",
            "Note: Patients seeking to exercise rights regarding medical records must contact their respective Hospital directly.": "टीप: वैद्यकीय रेकॉर्डच्या संदर्भात अधिकारांचा वापर करू इच्छिणाऱ्या रुग्णांनी त्यांच्या संबंधित हॉस्पिटलशी थेट संपर्क साधावा.",
            "We do not sell or trade personal data. We may share data only with Legal Authorities if required by Indian law or a court order.": "आम्ही वैयक्तिक डेटा विकत नाही किंवा व्यापार करत नाही. भारतीय कायदा किंवा न्यायालयाच्या आदेशानुसार आवश्यक असल्यास आम्ही केवळ कायदेशीर प्राधिकरणांशी डेटा शेअर करू शकतो.",
            "If you have any questions or grievances, contact our Data Protection Officer (DPO):": "तुमच्या काही शंका किंवा तक्रारी असल्यास, आमच्या डेटा संरक्षण अधिकारी (DPO) शी संपर्क साधा:",
            "Chat on WhatsApp": "व्हॉट्सॲपवर चॅट करा",
            "Call Us": "आम्हाला कॉल करा",
            "Email Us": "आम्हाला ईमेल करा",
            "Certificate Management": "प्रमाणपत्र व्यवस्थापन",
            "Prescription Management": "प्रिस्क्रिप्शन व्यवस्थापन",
            "Certificate Name": "प्रमाणपत्राचे नाव",
            "Certificate Content": "प्रमाणपत्राची माहिती",
            "Saved Certificates": "साठवलेली प्रमाणपत्रे",
            "Add New Certificate": "नवीन प्रमाणपत्र जोडा",
            "Update Certificate": "प्रमाणपत्र अपडेट करा",
            "Enter certificate name (e.g., Medical Certificate, Fitness Certificate)": "प्रमाणपत्राचे नाव प्रविष्ट करा (उदा. मेडिकल सर्टिफिकेट, फिटनेस सर्टिफिकेट)",
            "Write certificate content here...": "प्रमाणपत्राची माहिती येथे लिहा...",
            "Are you sure you want to delete this certificate?": "तुम्हाला खात्री आहे का की तुम्ही हे प्रमाणपत्र हटवू इच्छिता?",
            "No certificates found": "कोणतेही प्रमाणपत्र सापडले नाही",
            "Prescription Templates": "प्रिस्क्रिप्शन टेंप्लेट्स",
            "Create Prescription Template": "प्रिस्क्रिप्शन टेंप्लेट तयार करा",
            "Update Prescription Template": "प्रिस्क्रिप्शन टेंप्लेट अपडेट करा",
            "Update Template": "टेंप्लेट अपडेट करा",
            "Add Template": "टेंप्लेट जोडा",
            "Special instructions...": "विशेष सूचना...",
            "No templates found": "कोणतेही टेंप्लेट्स सापडले नाहीत",
            "Are you sure you want to delete this template?": "तुम्हाला खात्री आहे का की तुम्ही हे टेंप्लेट हटवू इच्छिता?",
            "Clear Info": "माहिती पुसा",
            "Update Prescription": "प्रिस्क्रिप्शन अपडेट करा",
            "Saved Prescriptions": "साठवलेली प्रिस्क्रिप्शन",
            "No prescriptions found": "कोणतेही प्रिस्क्रिप्शन सापडले नाही",
            "View": "पहा",
            "Enter Diagnosis...": "निदान प्रविष्ट करा...",
            "Are you sure you want to delete this prescription?": "तुम्हाला खात्री आहे का की तुम्ही हे प्रिस्क्रिप्शन हटवू इच्छिता?",
            "Clear All Medicines": "सर्व औषधे साफ करा",
            "Delete Prescription": "प्रिस्क्रिप्शन हटवा",
            "Are you sure you want to clear all added medicines?": "तुमची खात्री आहे की तुम्ही सर्व जोडलेली औषधे साफ करू इच्छिता?",
            "Search Patient...": "रुग्ण शोधा...",
            "Sent to Doctor": "डॉक्टरांकडे पाठवले",
            "Confirm": "निश्चित करा",
            "This action cannot be undone.": "ही कृती पूर्ववत केली जाऊ शकत नाही.",
            "Temperature": "तापमान",
            "SpO2": "SpO2",
            "Medical History": "वैद्यकीय इतिहास",
            "Full History": "संपूर्ण इतिहास",
            "Get Certificate": "प्रमाणपत्र मिळवा",
            "B/L/D": "ना/द/रा",
            "Medicine": "औषध",
            "Type": "प्रकार",
            "Dosage": "डोस",
            "Breakfast": "नाश्ता",
            "Lunch": "दुपारचे जेवण",
            "Dinner": "रात्रीचे जेवण",
            "Days": "दिवस",
            "Instr": "सूचना",
            "Medicine Name": "औषधाचे नाव",
            "Instruction": "सूचना",
            "Diagnosis": "निदान",
            "Allergy": "ॲलर्जी",
            "Complaint": "तक्रार",
            "Advice": "सल्ला",
            "Select": "निवडा",
            "Print": "प्रिंट",
            "PDF": "PDF",
            "Meds": "औषधे",
            "Get Your Certificate": "तुमचे प्रमाणपत्र मिळवा",
            "Patient Name:": "रुग्णाचे नाव:",
            "Certificate Type:": "प्रमाणपत्राचा प्रकार:",
            "Select Certificate": "प्रमाणपत्र निवडा",
            "Save Certificate": "प्रमाणपत्र सेव्ह करा",
            "Certificate Preview": "प्रमाणपत्राचे पूर्वावलोक",
            "Close Preview": "पूर्वावलोकन बंद करा",
            "Download PDF": "PDF डाउनलोड करा",
            "Export PDF": "PDF एक्सपोर्ट करा",
            "Reg. No:": "नोंदणी क्रमांक:",
            "Address:": "पत्ता:",
            "Mobile:": "मोबाईल:",
            "Weight": "वजन",
            "BP (Sys)": "बीपी (सिस)",
            "BP (Dia)": "बीपी (डाय)",
            "Pulse": "नाडी",
            "Temp": "तापमान",
            "Close": "बंद करा",
            "Preview & Print": "पूर्वावलोकन आणि प्रिंट",
            "Total Amount:": "एकूण रक्कम:",
            "Amount Received:": "प्राप्त रक्कम:",
            "Outstanding Amount:": "थकबाकी",
            "Save Bill": "बिल सेव्ह करा",
            "Save Prescription": "प्रिस्क्रिप्शन सेव्ह करा",
            "Submit": "सबमिट",
            "Submitting...": "सबमिट होत आहे...",
            "Export": "एक्सपोर्ट",
            "WhatsApp": "व्हॉट्सॲप",
            "Back": "मागे",
            "Y": "वर्ष",
            "M": "महिना",
            "D": "दिवस",
            "Edit Patient": "रुग्ण माहिती सुधारा",
            "O.A": "थकबाकी",
            "Date": "तारीख",
            "Enter Diagnosis": "निदान प्रविष्ट करा",
            "Clear": "साफ करा",
            "Add Medicine": "औषध जोडा",
            "Clear All": "सर्व औषधे काढा",
            "No medicines prescribed": "कोणतीही औषधे दिली नाहीत",
            "Before": "आधी",
            "After": "नंतर",
            "BEFORE": "जेवणाआधी",
            "AFTER": "जेवणानंतर",
            "Date:": "तारीख:",
            "Search:": "शोधा:",
            "Doctor:": "डॉक्टर:",
            "Enter Name...": "नाव प्रविष्ट करा...",
            "All Doctors": "सर्व डॉक्टर",
            "Sr. No.": "अनुक्रम क्रमांक",
            "Actions": "कृती",
            "Send to Doctor": "डॉक्टरांकडे पाठवा",
            "Already sent to doctor": "आधीच डॉक्टरांकडे पाठवले",
            "Sr.No.": "अनु.क्र.",
            "Name:": "नाव:",
            "Authorized Signatory": "अधिकृत स्वाक्षरी",
            "Addr:": "पत्ता:",
            "bpSystolic": "बीपी सिस्टोलिक",
            "bpDiastolic": "बीपी डायस्टोलिक",
            "Move Up": "वर हलवा",
            "Move Down": "खाली हलवा",
            "Search Medicine...": "औषध शोधा...",
            "Instructions": "सूचना",
            "Prescribed Medicines:": "दिलेली औषधे:",
            "the hospital": "रुग्णालय",
            "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}": "नमस्कार {{patientName}}, {{hospitalName}} कडून तुमचे प्रिस्क्रिप्शन तयार आहे.{{medicineText}}\n\nशुभेच्छा,\n{{hospitalName}}",
            "Validation Error": "व्हॅलिडेशन त्रुटी",
            "Bill amount is required": "बिल रक्कम आवश्यक आहे",
            "Prescription not submitted, please add medicines...": "प्रिस्क्रिप्शन सबमिट केले नाही, कृपया औषधे जोडा...",
            "Checkup Done...": "चेकअप पूर्ण झाले...",
            "Patient data submitted successfully.": "रुग्ण डेटा यशस्वीरित्या सबमिट केला.",
            "Checkup": "चेकअप",
            "Patient could not be deleted": "रुग्ण हटवता आला नाही",
            "Could not fetch patient details. Please try again.": "रुग्णाची माहिती मिळवता आली नाही. कृपया पुन्हा प्रयत्न करा.",
            "refresh patient list": "रुग्ण यादी रिफ्रेश करा",
            "Select Patient": "रुग्ण निवडा",
            "Save Details": "तपशील सेव्ह करा",
            "This patient is already available in today's checkup list!": "हा रुग्ण आजच्या चेकअप सूचीमध्ये आधीच उपलब्ध आहे!",
            "Could not {{action}} patient": "रुग्ण {{action}} करता आला नाही",
            "Patient {{action}} successfully!": "रुग्ण यशस्वीरित्या {{action}}!",
            "added": "जोडला",
            "updated": "अपडेट केला",
            "save": "सेव्ह",
            "update": "अपडेट",
            "B/L/D": "ना/दु/रा",
            "Sr No": "अनु.क्र.",
            "User Information": "वापरकर्ता माहिती",
            "User-Id": "वापरकर्ता-आयडी",
            "User Name": "वापरकर्ता नाव",
            "Role": "भूमिका",
            "No user records found.": "वापरकर्ता रेकॉर्ड सापडले नाहीत.",
            "Search User by Name...": "नावानुसार वापरकर्ता शोधा...",
            "New User": "नवीन वापरकर्ता",
            "Medicine Information": "औषध माहिती",
            "Medicine-Id": "औषध-आयडी",
            "Manufacturer": "उत्पादक",
            "Manufacturer Name": "उत्पादकाचे नाव",
            "Price": "किंमत",
            "Barcode": "बारकोड",
            "Expiry": "कालबाह्यता",
            "No medicine records found.": "औषधांचे रेकॉर्ड सापडले नाहीत.",
            "Search Medicine by Name...": "नावानुसार औषध शोधा...",
            "New Medicine": "नवीन औषध",
            "Edit Medicine Details": "औषध तपशील सुधारा",
            "Medicine ID": "औषध आयडी",
            "Medicine Name": "औषधाचे नाव",
            "Medicine Type": "औषधाचा प्रकार",
            "Disease": "आजार",
            "Expiry Date": "कालबाह्यता तारीख",
            "Save Changes": "बदल सेव्ह करा",
            "Search Patient": "रुग्ण शोधा",
            "Enter Name or Mobile": "नाव किंवा मोबाईल प्रविष्ट करा",
            "Patient Prescription": "रुग्ण प्रिस्क्रिप्शन",
            "Date & Time": "तारीख आणि वेळ",
            "This action cannot be undone.": "ही कृती पूर्ववत केली जाऊ शकत नाही.",
            "Confirm": "निश्चित करा",
            "Select Size": "आकार निवडा",
            "Orientation": "कल",
            "Format": "स्वरूप",
            "Portrait": "पोर्ट्रेट",
            "Landscape": "लँडस्केप",
            "PDF Format": "PDF स्वरूप",
            "Image Format": "इमेज स्वरूप",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Medicine Basic Info": "औषध मूलभूत माहिती",
            "Manufacturing & Pricing": "उत्पादन आणि किंमत",
            "Inventory Details": "इन्व्हेंटरी तपशील",
            "Datewise Billing": "तारीखवार बिलिंग",
            "Personal Details": "वैयक्तिक तपशील",
            "First Name": "पहिले नाव",
            "Middle Name": "मधले नाव",
            "Last Name": "आडनाव",
            "Account & Role": "खाते आणि भूमिका",
            "Select Role": "भूमिका निवडा",
            "Update User": "वापरकर्ता अपडेट करा",
            "Are you sure you want to save the changes to this user information?": "तुम्हाला खात्री आहे की तुम्ही या वापरकर्त्याच्या माहितीमध्ये बदल सेव्ह करू इच्छिता?",
            "Detail": "तपशील",
            "Search": "शोधा",
            "Action": "कृती",
            "Search Name or Mobile": "नाव किंवा मोबाईल शोधा",
            "Payment": "पेमेंट",
            "Payment type": "पेमेंटचा प्रकार",
            "Net Amount": "निव्वळ रक्कम",
            "Amount Received": "प्राप्त रक्कम",
            "Outstanding Amount": "थकबाकी",
            "Print Bill": "बिल प्रिंट करा",
            "Export Bill": "बिल एक्सपोर्ट करा",
            "WhatsApp Bill": "व्हॉट्सॲपवर पाठवा",
            "Total": "एकूण",
            "Portrait": "पोर्ट्रेट",
            "Landscape": "लँडस्केप",
            "PDF Format": "PDF स्वरूप",
            "Excel Format": "Excel स्वरूप",
            "EXPORT": "एक्सपोर्ट",
            "EXPORTING...": "एक्सपोर्ट होत आहे...",
            "Select Patient": "रुग्ण निवडा",
            "CLOSE PREVIEW": "पूर्वावलोकन बंद करा",
            "BILLING STATEMENTS PREVIEW": "बिलिंग स्टेटमेंट्स पूर्वावलोकन",
            "Update Medicine": "औषध अपडेट करा",
            "Are you sure you want to save the changes to this medicine information?": "तुम्हाला खात्री आहे की तुम्ही या औषधाच्या माहितीमध्ये बदल सेव्ह करू इच्छिता?",
            "Create New Bill": "नवीन बिल तयार करा",
            "Search Patient By Mobile Number": "मोबाईल नंबरने रुग्ण शोधा",
            "Expense Name": "खर्चाचे नाव",
            "Quantity": "प्रमाण",
            "Amount": "रक्कम",
            "Discount(%)": "सवलत (%)",
            "Enter transaction no.": "ट्रान्झॅक्शन नंबर प्रविष्ट करा",
            "Note": "टीप",
            "Enter Note": "टीप प्रविष्ट करा",
            "Submit with Print": "प्रिंटसह सबमिट करा",
            "REPORT PREVIEW": "रिपोर्ट पूर्वावलोकन",
            "Datewise Billing Report": "तारीखनुसार बिलिंग रिपोर्ट",
            "TOTAL": "एकूण",
            "Bill ID": "बिल आयडी",
            "Expenses Info": "खर्चाची माहिती",
            "Expenses Information": "खर्चाची माहिती",
            "No Expenses Added": "कोणतेही खर्च जोडलेले नाहीत",
            "No Expenses available": "कोणतेही खर्च उपलब्ध नाहीत",
            "Update Billing Details": "बिलिंग तपशील अपडेट करा",
            "Expense Items": "खर्च आयटम",
            "Add Expense": "खर्च जोडा",
            "Expense name": "खर्चाचे नाव",
            "Discount %": "सवलत %",
            "Net Amt": "निव्वळ रक्कम",
            "Actual Amount": "प्रत्यक्ष रक्कम",
            "Total Amount": "एकूण रक्कम",
            "Discount": "सवलत",
            "Discount (%)": "सवलत (%)",
            "CANCEL": "रद्द करा",
            "UPDATE BILL": "बिल अपडेट करा",
            "UPDATING...": "अपडेट होत आहे...",
            "Delete Bill": "बिल हटवा",
            "Update Bill": "बिल अपडेट करा",
            "Outstanding": "थकबाकी",
            "Billing Date": "बिलिंग तारीख",
            "Payment Type": "पेमेंट प्रकार",
            "Txn No": "ट्रान्झॅक्शन नंबर",
            "Update": "अपडेट",
            "Submit": "सबमिट करा",
            "Submitting...": "सबमिट होत आहे...",
            "DATEWISE BILLING REPORT": "तारीखनुसार बिलिंग रिपोर्ट",
            "Close": "बंद करा",
            "Select": "निवडा",
            "Clear": "साफ करा",
            "CLEAR": "साफ करा",
            "SUBMIT": "सबमिट करा",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Select Size": "आकार निवडा",
            "Orientation": "दिशा",
            "Format": "स्वरूप",
            "No patients found": "कोणताही रुग्ण सापडला नाही",
            "Error fetching patients": "रुग्ण माहिती मिळवण्यात त्रुटी",
            "Error fetching billing data": "बिलिंग डेटा मिळवण्यात त्रुटी",
            "Bill deleted successfully": "बिल यशस्वीरित्या हटवले",
            "Error deleting bill": "बिल हटवण्यात त्रुटी",
            "Please enter expense name before adding new one.": "नवीन खर्च जोडण्यापूर्वी कृपया खर्चाचे नाव प्रविष्ट करा.",
            "Please enter quantity greater than 0.": "कृपया ० पेक्षा जास्त प्रमाण प्रविष्ट करा.",
            "Please enter valid amount.": "कृपया वैध रक्कम प्रविष्ट करा.",
            "At least one expense must remain.": "किमान एक खर्च असणे आवश्यक आहे.",
            "Please select a patient.": "कृपया रुग्ण निवडा.",
            "Please add at least one expense.": "कृपया किमान एक खर्च जोडा.",
            "Expense name missing (row {{row}}).": "खर्चाचे नाव गहाळ आहे (ओळ {{row}}).",
            "Invalid amount in row {{row}}.": "ओळ {{row}} मध्ये अवैध रक्कम.",
            "Quantity must be greater than 0 (row {{row}}).": "प्रमाण ० पेक्षा जास्त असावे (ओळ {{row}}).",
            "Please enter valid amount received.": "कृपया प्राप्त झालेली वैध रक्कम प्रविष्ट करा.",
            "Updated successfully": "यशस्वीरित्या अपडेट केले",
            "Update failed": "अपडेट अयशस्वी",
            "Print Bill": "बिल प्रिंट करा",
            "Export Bill": "बिल एक्सपोर्ट करा",
            "WhatsApp Bill": "व्हॉट्सॲपवर बिल पाठवा",
            "Please select both dates.": "कृपया दोन्ही तारखा निवडा.",
            "Failed to fetch billing data": "बिलिंग डेटा मिळवण्यात अपयश",
            "No data to print": "प्रिंट करण्यासाठी कोणताही डेटा नाही",
            "Cash": "रोख",
            "Card": "कार्ड",
            "UPI": "युपीआय",
            "Please select a start date": "कृपया सुरुवातीची तारीख निवडा",
            "Please select an end date": "कृपया शेवटची तारीख निवडा",
            "End date cannot be before start date": "शेवटची तारीख सुरुवातीच्या तारखेच्या आधी असू शकत नाही",
            "Date range cannot exceed 90 days from start date": "तारीख श्रेणी सुरुवातीच्या तारखेपासून ९० दिवसांपेक्षा जास्त असू शकत नाही",
            "Print After Save": "सेव्ह केल्यानंतर प्रिंट करा",
            "Create IPD Bill": "आयपीडी बिल तयार करा",
            "Actual Amount": "प्रत्यक्ष रक्कम",
            "Net": "निव्वळ",
            "Disc": "सवलत",
            "Qty": "प्रमाण",
            "Wait...": "प्रतीक्षा करा...",
            "Update Entry": "नोंद अपडेट करा",
            "Update Visit Record": "भेट रेकॉर्ड अपडेट करा",
            "Add Record": "रेकॉर्ड जोडा",
            "Sr.": "अनु.",
            "Amount Received:": "प्राप्त रक्कम:",
            "Outstanding Amount:": "थकबाकी:",
            "Payment Type:": "पेमेंट प्रकार:",
            "Billing Date:": "बिलिंग तारीख:",
            "Billing Statement": "बिल स्टेटमेंट",
            "New Bill": "नवीन बिल",
            "Billing History": "बिलिंग इतिहास",
            "Datewise Billing": "तारीखवार बिलिंग",
            "BILLING STATEMENTS PREVIEW": "बिल स्टेटमेंट पूर्वावलोकन",
            "Report Date": "अहवाल तारीख",
            "Total Records": "एकूण रेकॉर्ड",
            "Outstanding Only": "फक्त थकबाकी",
            "Search Patient": "रुग्ण शोधा",
            "Enter Name or Mobile": "नाव किंवा मोबाईल प्रविष्ट करा",
            "Search Name or Mobile": "नाव किंवा मोबाईल शोधा",
            "Payment": "पेमेंट",
            "All": "सर्व",
            "Bill ID": "बिल आयडी",
            "Expenses Info": "खर्चाची माहिती",
            "View": "पहा",
            "No Expenses Added": "कोणताही खर्च जोडला नाही",
            "Expenses Information": "खर्चाची माहिती",
            "No Expenses available": "कोणताही खर्च उपलब्ध नाही",
            "Update Billing Details": "बिलिंग तपशील अपडेट करा",
            "Expense Items": "खर्चाचे आयटम",
            "Add Expense": "खर्च जोडा",
            "Expense name": "खर्चाचे नाव",
            "Discount %": "सवलत %",
            "Net Amount": "निव्वळ रक्कम",
            "Outstanding": "थकबाकी",
            "Net Amt": "निव्वळ रक्कम",
            "Search Patient By Mobile Number": "मोबाईल नंबरने रुग्ण शोधा",
            "Authorized Signatory": "अधिकृत स्वाक्षरी",
            "Total Amt": "एकूण रक्कम",
            "Discount(%)": "सवलत (%)",
            "Select Size": "आकार निवडा",
            "Orientation": "स्थिती",
            "Portrait": "उभे (Portrait)",
            "Landscape": "आडवे (Landscape)",
            "PDF Format": "पीडीएफ फॉरमॅट",
            "Excel Format": "एक्सेल फॉरमॅट",
            "EXPORTING...": "एक्सपोर्ट होत आहे...",
            "EXPORT": "एक्सपोर्ट",
            "Select Patient": "रुग्ण निवडा",
            "Patient Id": "रुग्ण आयडी",
            "Select": "निवडा",
            "Bill Receipt": "बिल पावती",
            "Amount Received": "प्राप्त रक्कम",
            "Outstanding Amount": "थकबाकी",
            "Payment Type": "पेमेंट प्रकार",
            "Txn No": "व्यवहार क्र.",
            "IPD DATEWISE BILLING REPORT": "IPD तारीखनिहाय बिलिंग अहवाल",
            "Sr No": "अ.क्र.",
            "No services found": "कोणतीही सेवा सापडली नाही",
            "Authority Sign / Doctor Sign": "अधिकृत स्वाक्षरी / डॉक्टर स्वाक्षरी",
            "Patient": "रुग्ण",
            "the hospital": "रुग्णालय",
            "is ready": "तयार आहे",
            "regards": "शुभेच्छा",
            "WhatsApp": "व्हॉट्सॲप",
            "Save": "सेव्ह करा",
            "Saving...": "सेव्ह होत आहे...",
            "Print": "प्रिंट",
            "Export": "एक्सपोर्ट",
            "CLOSE": "बंद करा",
            "Update Billing": "बिलिंग अपडेट करा",
            "Total Amount": "एकूण रक्कम",
            "From": "पासून",
            "To": "पर्यंत",
            "IPD Datewise Billing Report": "IPD तारीखनिहाय बिलिंग अहवाल",
            "SUBMIT": "सबमिट करा",
            "CLEAR": "क्लिअर करा",
            "Sr.No": "अ.क्र.",
            "Expense": "खर्च",
            "Total Amt": "एकूण रक्कम",
            "Discount(%)": "सवलत (%)",
            "Net Amt": "निव्वळ रक्कम",
            "Enter Note": "टीप प्रविष्ट करा",
            "Add Item": "आयटम जोडा",
            "Note": "टीप",
            "No Record found": "रेकॉर्ड सापडला नाही",
            "REPORT PREVIEW": "अहवाल पूर्वावलोकन",
            "CLOSE PREVIEW": "पूर्वावलोकन बंद करा",
            "IPD BILLING STATEMENTS PREVIEW": "आयपीडी बिल स्टेटमेंट पूर्वावलोकन",
            "Consulting Physician": "सल्लागार चिकित्सक",
            "Account Credentials": "खाते क्रेडेंशियल्स",
            "Confirm Password *": "पासवर्डची पुष्टी करा *",
            "Register User": "वापरकर्त्याची नोंदणी करा",
            "Mobile No": "मोबाईल नंबर",
            "Degree": "पदवी",
            "Password": "पासवर्ड",
            "password": "पासवर्ड",
            "Confirm password": "पासवर्डची पुष्टी करा",
            "Certificates": "प्रमाणपत्रे",
            "Search Certificate by Patient:": "रुग्णानुसार प्रमाणपत्र शोधा:",
            "Search Patient by Name or Mobile": "नाव किंवा मोबाईलने रुग्ण शोधा",
            "CERTIFICATE REPORT PREVIEW": "प्रमाणपत्र रिपोर्ट पूर्वावलोकन",
            "Certificate Description": "प्रमाणपत्र वर्णन",
            "Copy": "कॉपी करा",
            "IPD No": "आयपीडी नंबर",
            "Phone": "फोन",
            "Floor": "मजला",
            "Ward/Bed": "वॉर्ड/बेड",
            "Admission Date": "प्रवेश तारीख",
            "ACTIVE": "सक्रिय",
            "ALL": "सर्व",
            "DISCHARGED": "डिस्चार्ज केलेले",
            "CANCELLED": "रद्द केलेले",
            "TRANSFERRED": "हस्तांतरित केलेले",
            "Action": "कृती",
            "Start Date:": "प्रारंभ तारीख:",
            "End Date:": "अंतिम तारीख:",
            "Start Date": "प्रारंभ तारीख",
            "End Date": "अंतिम तारीख",
            "Billing Statements": "बिल स्टेटमेंट",
            "Billing Statement": "बिल स्टेटमेंट",
            "Disc(%)": "सवलत (%)",
            "Status:": "स्थिती:",
            "Record not found": "रेकॉर्ड सापडला नाही",
            "IPD Patient List": "आयपीडी रुग्ण यादी",
            "IPD": "आय.पी.डी.",
            "Create IPD": "नवीन आयपीडी",
            "Availability": "उपलब्धता",
            "Billing": "बिलिंग",
            "Reports": "रिपोर्टींग",
            "IPD Config": "आयपीडी सेटिंग",
            "View": "पहा",
            "Name": "नाव",
            "Mobile": "मोबाईल",
            "ID": "आयडी",
            "VIEW DESCRIPTION": "वर्णन पहा",
            "EXPORT PDF": "PDF एक्सपोर्ट करा",
            "DELETE": "हटवा",
            "No content available...": "कोणतीही सामग्री उपलब्ध नाही...",
            "No Record found": "रेकॉर्ड सापडला नाही",
            "Delete Certificate": "प्रमाणपत्र हटवा",
            "Are you sure you want to delete this certificate?": "तुम्हाला खात्री आहे की तुम्ही हे प्रमाणपत्र हटवू इच्छिता?",
            "Copied to clipboard": "क्लिपबोर्डवर कॉपी केले",
            "Edit Admission Details": "प्रवेश तपशील सुधारा",
            "Admission Notes / Remarks": "प्रवेश टिपा / शेरा",
            "Enter remarks... (Please specify reason for Transfer/Cancellation if applicable)": "शेरा नोंदवा... (लागू असल्यास बदली/रद्दीकरणाचे कारण स्पष्ट करा)",
            "Delete Admission": "प्रवेश हटवा",
            "Update Admission": "प्रवेश अपडेट करा",
            "Discharge Patient": "रुग्णाला डिस्चार्ज द्या",
            "Add Summary": "सारांश जोडा",
            "DOD": "डिस्चार्ज तारीख",
            "Discharge Time": "डिस्चार्ज वेळ",
            "Discharge Type": "डिस्चार्ज प्रकार",
            "Condition at Discharge": "डिस्चार्ज वेळची स्थिती",
            "AMA": "वैद्यकीय सल्ल्याविरुद्ध (AMA)",
            "Against Medical Advice (AMA)": "वैद्यकीय सल्ल्याविरुद्ध (AMA)",
            "Referral": "रेफरल",
            "Deceased": "मृत",
            "Please select Discharge Type": "कृपया डिस्चार्ज प्रकार निवडा",
            "Payment Clearance": "पेमेंट क्लिअरन्स",
            "Cleared": "क्लिअर",
            "Pending": "लंबित",
            "Please Clear Payment to Proceed": "पुढील कार्यवाहीसाठी कृपया पेमेंट क्लिअर करा",
            "Next Appointment (if any)": "पुढील भेट (असल्यास)",
            "Detailed Discharge Summary": "तपशीलवार डिस्चार्ज सारांश",
            "Write comprehensive clinical notes, treatment given, and advice.": "सर्वसमावेशक क्लिनिकल नोट्स, दिलेले उपचार आणि सल्ला लिहा.",
            "Edit Mode": "एडीट मोड",
            "Preview Mode": "पूर्वावलोकन मोड",
            "Start typing the detailed discharge summary here...": "येथे तपशीलवार डिस्चार्ज सारांश टाइप करण्यास सुरुवात करा...",
            "No content to preview.": "पूर्वावलोकनासाठी कोणतीही सामग्री नाही.",
            "Discard": "रद्द करा",
            "Save Summary": "सारांश जतन करा",
            "Discharge date (DOD) is required": "डिस्चार्ज तारीख (DOD) आवश्यक आहे",
            "Discharge time is required": "डिस्चार्ज वेळ आवश्यक आहे",
            "Detailed Clinical Summary is mandatory to proceed with discharge.": "डिस्चार्जसाठी तपशीलवार क्लिनिकल सारांश अनिवार्य आहे.",
            "Please check Payment Clearance. Status must be 'Cleared' to proceed.": "कृपया पेमेंट क्लिअरन्स तपासा. पुढे जाण्यासाठी स्थिती 'क्लिअर' असणे आवश्यक आहे.",
            "Discharging...": "डिस्चार्ज होत आहे...",
            "Discharge": "डिस्चार्ज",
            "IPD Number": "आयपीडी नंबर",
            "IPD ID": "आयपीडी आयडी",
            "Ward / Bed": "वॉर्ड / बेड",
            "Room Floor": "मजला",
            "Admission Info": "प्रवेश माहिती",
            "Consulting Dr.": "सल्लागार डॉक्टर",
            "Reason for Admission": "प्रवेशाचे कारण",
            "Guardian Details": "पालक तपशील",
            "Clinical Data": "क्लिनिकल डेटा",
            "Patient Vitals": "रुग्णाचे व्हायटल्स",
            "BP": "बीपी",
            "Temp": "तापमान",
            "Identification & Insurance": "ओळख आणि विमा",
            "Adhar Card": "आधार कार्ड",
            "PAN Card": "पॅन कार्ड",
            "Insurance No.": "विमा क्रमांक",
            "Discharge Summary": "डिस्चार्ज सारांश",
            "Follow-up Date": "फॉलो-अप तारीख",
            "Doctor's Clinical Summary & Treatment": "डॉक्टरांचा क्लिनिकल सारांश आणि उपचार",
            "Enlarge View": "मोठा करा",
            "No detailed discharge summary recorded.": "कोणताही तपशीलवार डिस्चार्ज सारांश रेकॉर्ड केलेला नाही.",
            "Additional Notes:": "अतिरिक्त टीपा:",
            "PRINT SUMMARY": "सारांश प्रिंट करा",
            "CLOSE DETAILS": "तपशील बंद करा",
            "Clinical Summary & Treatment": "क्लिनिकल सारांश आणि उपचार",
            "CLOSE FULL SCREEN": "पूर्ण स्क्रीन बंद करा",
            "Symptoms Type": "लक्षणांचा प्रकार",
            "Symptoms Title": "लक्षणांचे शीर्षक",
            "Symptoms in Detail": "तपशीलवार लक्षणे",
            "Primary Diagnosis": "प्राथमिक निदान",
            "IPD Report": "आयपीडी रिपोर्ट",
            "Guardian Info": "पालकाची माहिती",
            "Contact": "संपर्क",
            "Clinical Information": "क्लिनिकल माहिती",
            "Discharge & Outcome": "डिस्चार्ज आणि परिणाम",
            "Discharge Date & Time": "डिस्चार्ज तारीख आणि वेळ",
            "TPA / Insurance Info": "TPA / विमा माहिती",
            "PENDING": "प्रलंबित",
            "Expires": "कालबाह्य",
            "Cash Patient": "कॅश पेशंट",
            "Additional Notes / Remarks": "अतिरिक्त नोट्स / शेरा",
            "Update Billing": "बिलिंग अपडेट करा",
            "Billing Date": "बिलिंग तारीख",
            "Payment Type": "पेमेंट प्रकार",
            "Expense Items": "खर्च आयटम",
            "Add Expense": "खर्च जोडा",
            "Expense name": "खर्चाचे नाव",
            "Amount": "रक्कम",
            "Quantity": "प्रमाण",
            "Total Amt": "एकूण रक्कम",
            "Discount %": "सवलत %",
            "Net Amt": "निव्वळ रक्कम",
            "Total Amount": "एकूण रक्कम",
            "Amount Received": "प्राप्त रक्कम",
            "Outstanding": "थकबाकी",
            "Cancel": "रद्द करा",
            "Save": "सेव्ह करा",
            "Delete Bill": "बिल हटवा",
            "Are you sure you want to delete this bill?": "तुम्हाला खात्री आहे की तुम्ही हे बिल हटवू इच्छिता?",
            "Update": "अपडेट",
            "Update Bill": "बिल अपडेट करा",
            "Are you sure you want to save the changes to this bill?": "तुम्हाला खात्री आहे की तुम्ही या बिलातील बदल सेव्ह करू इच्छिता?",
            "Diagnosis": "निदान",
            "Symptoms": "लक्षणे",
            "Aadhar No": "आधार नंबर",
            "PAN No": "पॅन नंबर",
            "No Diagnosis Recorded": "निदान नोंदवलेले नाही",
            "General": "सामान्य",
            "No symptoms described": "लक्षणांचे वर्णन केलेले नाही",
            "Additional Notes / Remarks:": "अतिरिक्त नोट्स / शेरा:",
            "Consulting Doctor": "सल्लागार डॉक्टर",
            "Reason for Admission": "प्रवेशाचे कारण",
            "Ward / Bed": "वॉर्ड / बेड",
            "Room Floor": "खोलीचा मजला",
            "Admission Details": "प्रवेश तपशील",
            "IPD ADMISSION DETAILS": "आयपीडी प्रवेश तपशील",
            "Total of": "एकूण",
            "patients found under category": "रुग्ण श्रेणीमध्ये आढळले",
            "Report Period": "रिपोर्ट कालावधी",
            "IPD Patient Report": "आयपीडी रुग्ण रिपोर्ट",
            "Submit": "सबमिट करा",
            "Preview": "पूर्वावलोकन",
            "Export": "एक्सपोर्ट",
            "Print": "प्रिंट",
            "Start Date:": "प्रारंभ तारीख:",
            "End Date:": "अंतिम तारीख:",
            "Status:": "स्थिती:",
            "To": "ते",
            "Period": "कालावधी",
            "Total Records": "एकूण रेकॉर्ड",
            "Generated on": "रोजी व्युत्पन्न केले",
            "Page": "पृष्ठ",
            "of": "चे",
            "Of": "चे",
            "Ward/Bed": "वॉर्ड/बेड",
            "Adm. Date": "प्रवेश तारीख",
            "Admission Date": "प्रवेश तारीख",
            "IPD No": "आयपीडी नंबर",
            "Phone": "फोन",
            "Doctor": "डॉक्टर",
            "Floor": "मजला",
            "View": "पहा",
            "Edit Admission": "प्रवेश सुधारा",
            "Discharge Patient": "रुग्णास डिस्चार्ज द्या",
            "Discharge": "डिस्चार्ज",
            "View Details": "तपशील पहा",
            "PDF Preview": "PDF पूर्वावलोकन",
            "Add Summary": "सारांश जोडा",
            "Detailed Discharge Summary": "तपशीलवार डिस्चार्ज सारांश",
            "Write comprehensive clinical notes, treatment given, and advice.": "सर्वसमावेशक क्लिनिकल नोट्स, दिलेले उपचार आणि सल्ला लिहा.",
            "Edit Mode": "एडिट मोड",
            "Preview Mode": "पूर्वावलोकन मोड",
            "Start typing the detailed discharge summary here...": "येथे तपशीलवार डिस्चार्ज सारांश टाइप करण्यास प्रारंभ करा...",
            "No content to preview.": "पूर्वावलोकनासाठी कोणतीही सामग्री नाही.",
            "Discard": "रद्द करा",
            "Save Summary": "सारांश सेव्ह करा",
            "IPD Number": "आयपीडी नंबर",
            "Ward / Bed": "वॉर्ड / बेड",
            "Room Floor": "खोलीचा मजला",
            "Consulting Dr.": "सल्लागार डॉ.",
            "Diagnosis": "निदान",
            "Symptoms": "लक्षणे",
            "Patient Profile": "रुग्ण माहिती",
            "Registration No.": "नोंदणी क्रमांक",
            "Mobile": "मोबाईल",
            "Blood Group": "रक्त गट",
            "Referred By": "कोणाकडून संदर्भित",
            "Address": "पत्ता",
            "Identification & Insurance": "ओळख आणि विमा",
            "Adhar Card": "आधार कार्ड",
            "PAN Card": "पॅन कार्ड",
            "Insurance No.": "विमा क्रमांक",
            "Discharged Patient Details": "डिस्चार्ज केलेल्या रुग्णाचा तपशील",
            "Discharge Summary": "डिस्चार्ज सारांश",
            "Discharge Date": "डिस्चार्ज तारीख",
            "Discharge Type": "डिस्चार्ज प्रकार",
            "Condition": "स्थिती",
            "Follow-up Date": "फॉलो-अप तारीख",
            "Doctor's Clinical Summary & Treatment": "डॉक्टरांचा क्लिनिकल सारांश आणि उपचार",
            "Enlarge View": "मोठा करा",
            "Additional Notes:": "अतिरिक्त टीपा:",
            "CLOSE DETAILS": "तपशील बंद करा",
            "CLOSE FULL SCREEN": "पूर्ण स्क्रीन बंद करा",
            "PRINT SUMMARY": "सारांश प्रिंट करा",
            "EXPORT PDF": "PDF एक्सपोर्ट करा",
            "Total of": "एकूण",
            "patients found under category": "रुग्ण श्रेणीमध्ये आढळले",
            "Report period": "रिपोर्ट कालावधी",
            "Admission Info": "प्रवेश माहिती",
            "Guardian Details": "पालकाचे तपशील",
            "Clinical Data": "क्लिनिकल डेटा",
            "Patient Vitals": "रुग्णाचे व्हायटल्स",
            "BP": "बीपी",
            "Pulse": "नाडी",
            "Temp": "तापमान",
            "SpO2": "SpO2",
            "Wt": "वजन",
            "Aadhar No": "आधार नंबर",
            "PAN No": "पॅन नंबर",
            "Mobile No": "मोबाईल नंबर",
            "IPD ADMISSION DETAILS": "आयपीडी प्रवेश तपशील",
            "Consulting Doctor": "सल्लागार डॉक्टर",
            "Admission Details": "प्रवेश तपशील",
            "Reason for Admission": "प्रवेशाचे कारण",
            "Guardian Info": "पालकाची माहिती",
            "Contact": "संपर्क",
            "Name": "नाव",
            "Relation": "नाते",
            "Clinical Information": "क्लिनिकल माहिती",
            "No Diagnosis Recorded": "निदान नोंदवलेले नाही",
            "General": "सामान्य",
            "No symptoms described": "लक्षणांचे वर्णन केलेले नाही",
            "Discharge & Outcome": "डिस्चार्ज आणि परिणाम",
            "Discharge Date & Time": "डिस्चार्ज तारीख आणि वेळ",
            "TPA / Insurance Info": "TPA / विमा माहिती",
            "PENDING": "प्रलंबित",
            "Expires": "कालबाह्य",
            "Cash Patient": "कॅश पेशंट",
            "Additional Notes / Remarks": "अतिरिक्त नोट्स / शेरा",
            "Additional Notes / Remarks:": "अतिरिक्त नोट्स / शेरा:",
            "Admission Reason": "प्रवेशाचे कारण",
            "Date & Time": "तारीख आणि वेळ",
            "Admission Info": "प्रवेश माहिती",
            "Consulting Dr.": "सल्लागार डॉ.",
            "Guardian Details": "पालकाचे तपशील",
            "Clinical Data": "क्लिनिकल डेटा",
            "Patient Vitals": "रुग्णाचे व्हायटल्स",
            "Identification & Insurance": "ओळख आणि विमा",
            "Discharged Patient Details": "डिस्चार्ज केलेल्या रुग्णाचा तपशील",
            "Discharge Summary": "डिस्चार्ज सारांश",
            "Follow-up Date": "फॉलो-अप तारीख",
            "Doctor's Clinical Summary & Treatment": "डॉक्टरांचा क्लिनिकल सारांश आणि उपचार",
            "Enlarge View": "मोठा करा",
            "Additional Notes:": "अतिरिक्त टीपा:",
            "CLOSE DETAILS": "तपशील बंद करा",
            "CLOSE FULL SCREEN": "पूर्ण स्क्रीन बंद करा",
            "PRINT SUMMARY": "सारांश प्रिंट करा",
            "EXPORT PDF": "PDF एक्सपोर्ट करा",
            "Total of": "एकूण",
            "patients found under category": "रुग्ण श्रेणीमध्ये आढळले",
            "Report details": "रिपोर्ट तपशील",
            "Guardian Info": "पालकाची माहिती",
            "Contact": "संपर्क",
            "Clinical Information": "क्लिनिकल माहिती",
            "Discharge & Outcome": "डिस्चार्ज आणि परिणाम",
            "Discharge Date & Time": "डिस्चार्ज तारीख आणि वेळ",
            "TPA / Insurance Info": "TPA / विमा माहिती",
            "PENDING": "प्रलंबित",
            "Expires": "कालबाह्य",
            "Cash Patient": "कॅश पेशंट",
            "Additional Notes / Remarks": "अतिरिक्त नोट्स / शेरा",
            "Additional Notes / Remarks:": "अतिरिक्त नोट्स / शेरा:",
            "Admission Reason": "प्रवेशाचे कारण",
            "Date & Time": "तारीख आणि वेळ",
            "Admission Info": "प्रवेश माहिती",
            "Consulting Dr.": "सल्लागार डॉ.",
            "Guardian Details": "पालकाचे तपशील",
            "Clinical Data": "क्लिनिकल डेटा",
            "Patient Vitals": "रुग्णाचे व्हायटल्स",
            "Identification & Insurance": "ओळख आणि विमा",
            "Discharged Patient Details": "डिस्चार्ज केलेल्या रुग्णाचा तपशील",
            "Discharge Summary": "डिस्चार्ज सारांश",
            "Follow-up Date": "फॉलो-अप तारीख",
            "Doctor's Clinical Summary & Treatment": "डॉक्टरांचा क्लिनिकल सारांश आणि उपचार",
            "Enlarge View": "मोठा करा",
            "Additional Notes:": "अतिरिक्त टीपा:",
            "CLOSE DETAILS": "तपशील बंद करा",
            "CLOSE FULL SCREEN": "पूर्ण स्क्रीन बंद करा",
            "PRINT SUMMARY": "सारांश प्रिंट करा",
            "EXPORT PDF": "PDF एक्सपोर्ट करा",
            "Total of": "एकूण",
            "patients found under category": "रुग्ण श्रेणीमध्ये आढळले",
            "Report details": "रिपोर्ट तपशील",
            "Update Billing": "बिलिंग अपडेट करा",
            "Billing Date": "बिलिंग तारीख",
            "Payment Type": "पेमेंट प्रकार",
            "Expense Items": "खर्च आयटम",
            "Add Expense": "खर्च जोडा",
            "Expense name": "खर्चाचे नाव",
            "Amount": "रक्कम",
            "Quantity": "प्रमाण",
            "Total Amt": "एकूण रक्कम",
            "Discount %": "सवलत %",
            "Net Amt": "निव्वळ रक्कम",
            "Total Amount": "एकूण रक्कम",
            "Amount Received": "प्राप्त रक्कम",
            "Outstanding": "थकबाकी",
            "Cancel": "रद्द करा",
            "Save": "सेव्ह करा",
            "Delete Bill": "बिल हटवा",
            "Are you sure you want to delete this bill?": "तुम्हाला खात्री आहे की तुम्ही हे बिल हटवू इच्छिता?",
            "Update Bill": "बिल अपडेट करा",
            "Are you sure you want to save the changes to this bill?": "तुम्हाला खात्री आहे की तुम्ही या बिलातील बदल सेव्ह करू इच्छिता?",
            "Update": "अपडेट",
            "Cash": "कॅश",
            "Card": "कार्ड",
            "UPI": "UPI",
            "IPD No": "आयपीडी नंबर",
            "Adm. Date": "प्रवेश तारीख",
            "Aadhar Number": "आधार नंबर",
            "PAN Number": "पॅन नंबर",
            "Guardian Contact Number": "पालकाचा संपर्क क्रमांक",
            "Discharge Date": "डिस्चार्ज तारीख",
            "Select Size": "आकार निवडा",
            "Orientation": "ओरिएंटेशन",
            "Portrait": "पोर्ट्रेट",
            "Landscape": "लँडस्केप",
            "Format": "फॉर्मेट",
            "PDF Format": "PDF फॉर्मेट",
            "Excel Format": "Excel फॉर्मेट",
            "EXPORTING...": "एक्सपोर्ट होत आहे...",
            "EXPORT": "एक्सपोर्ट",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Loading...": "लोड होत आहे...",
            "Discharging...": "डिस्चार्ज होत आहे...",
            "Discharge": "डिस्चार्ज",
            "Against Medical Advice (AMA)": "वैद्यकीय सल्ल्याविरुद्ध (AMA)",
            "Referral": "रेफरल",
            "Deceased": "मृत",
            "Cleared": "क्लिअर केलेले",
            "Normal": "सामान्य",
            "Please Clear Payment to Proceed": "कृपया पुढे जाण्यासाठी पेमेंट क्लिअर करा",
            "Detailed Discharge Summary": "तपशीलवार डिस्चार्ज सारांश",
            "Write comprehensive clinical notes, treatment given, and advice.": "सर्वसमावेशक क्लिनिकल नोट्स, दिलेले उपचार आणि सल्ला लिहा.",
            "Edit Mode": "एडिट मोड",
            "Preview Mode": "पूर्वावलोकन मोड",
            "Start typing the detailed discharge summary here...": "येथे तपशीलवार डिस्चार्ज सारांश टाइप करण्यास प्रारंभ करा...",
            "No content to preview.": "पूर्वावलोकनासाठी कोणतीही सामग्री नाही.",
            "Discard": "रद्द करा",
            "Save Summary": "सारांश सेव्ह करा",
            "Please Add Detailed Clinical Summary before printing.": "कृपया प्रिंट करण्यापूर्वी तपशीलवार क्लिनिकल सारांश जोडा.",
            "Please Add Detailed Clinical Summary before exporting.": "कृपया एक्सपोर्ट करण्यापूर्वी तपशीलवार क्लिनिकल सारांश जोडा.",
            "Detailed Clinical Summary is mandatory to proceed with discharge.": "डिस्चार्जसाठी तपशीलवार क्लिनिकल सारांश अनिवार्य आहे.",
            "Discharge date (DOD) is required": "डिस्चार्ज तारीख (DOD) आवश्यक आहे",
            "Discharge time is required": "डिस्चार्ज वेळ आवश्यक आहे",
            "Discharge type is required": "डिस्चार्ज प्रकार आवश्यक आहे",
            "Please select Discharge Type": "कृपया डिस्चार्ज प्रकार निवडा",
            "Status": "स्थिती",
            "ACTIVE": "सक्रिय",
            "ALL": "सर्व",
            "DISCHARGED": "डिस्चार्ज केलेले",
            "CANCELLED": "रद्द केलेले",
            "TRANSFERRED": "हस्तांतरित केलेले",
            "Eating or vomit": "खाणे किंवा उलट्या होणे",
            "Breathing difficulty": "श्वास घेण्यास त्रास होणे",
            "Guardian Information": "पालक माहिती",
            "Guardian Name": "पालकाचे नाव",
            "Relation": "नाते",
            "Select Relation": "नाते निवडा",
            "Father": "वडील",
            "Mother": "आई",
            "Spouse": "पती/पत्नी",
            "Son": "मुलगा",
            "Daughter": "मुलगी",
            "Brother": "भाऊ",
            "Sister": "बहीण",
            "Height (cm)": "उंची (सेमी)",
            "Weight (kg)": "वजन (किलो)",
            "BP Systolic (mmHg)": "बीपी सिस्टोलिक (mmHg)",
            "BP Diastolic (mmHg)": "बीपी डायस्टोलिक (mmHg)",
            "Pulse (bpm)": "नाडी (bpm)",
            "Temperature (°F)": "तापमान (°F)",
            "TPA ID": "टीपीए आयडी",
            "TPA Validity": "टीपीए वैधता",
            "Adhar/National ID": "आधार/राष्ट्रीय आयडी",
            "PAN Card Number": "पॅन कार्ड नंबर",
            "Insurance Card/Details": "विमा कार्ड/तपशील",
            "12 digits": "१२ अंक",
            "10 characters": "१० अक्षरे",
            "Patient ID": "रुग्ण आयडी",
            "Age": "वय",
            "DOB": "जन्म तारीख",
            "Gender": "लिंग",
            "Patient Name": "रुग्णाचे नाव",
            "DOA": "प्रवेश तारीख",
            "Admission Time": "प्रवेशाची वेळ",
            "PID": "पीआयडी",
            "Yrs": "वर्षे",
            "Admission Details": "प्रवेश तपशील",
            "Admission Date & Time": "प्रवेशाची तारीख आणि वेळ",
            "Floor Number": "मजला क्रमांक",
            "Select Floor": "मजला निवडा",
            "Ward/Room Type": "वॉर्ड/खोलीचा प्रकार",
            "Select Ward": "वॉर्ड निवडा",
            "Bed Number": "बेड नंबर",
            "Select Bed": "बेड निवडा",
            "Male": "पुरुष",
            "Female": "स्त्री",
            "male": "पुरुष",
            "female": "स्त्री",
            "M": "पुरुष",
            "F": "स्त्री",
            "m": "पुरुष",
            "f": "स्त्री",
            "Other": "इतर",
            "Fever": "ताप",
            "Pain": "वेदना",
            "e.g., Stable": "उदा., स्थिर",
            "General": "सामान्य",
            "Friend": "मित्र",
            "spo2": "SpO2",
            "SpO2": "SpO2",
            "Referred By": "कोणाकडून संदर्भित",
            "Referred By Dr": "डॉक्टरांकडून संदर्भित",
            "Cancel Admission": "प्रवेश रद्द करा",
            "Reason for Cancellation": "रद्द करण्याचे कारण",
            "Please enter the reason for cancelling this admission...": "कृपया हा प्रवेश रद्द करण्याचे कारण प्रविष्ट करा...",
            "Go Back": "मागे जा",
            "Confirm Cancellation": "रद्द करण्याची पुष्टी करा",
            "Admission updated successfully!": "प्रवेश यशस्वीरित्या अपडेट केला!",
            "Error updating admission: ": "प्रवेश अपडेट करताना त्रुटी: ",
            "Admission deleted successfully!": "प्रवेश यशस्वीरित्या हटविला गेला!",
            "Delete failed: ": "हटविणे अयशस्वी: ",
            "Confirm Delete": "हटविण्याची पुष्टी करा",
            "Are you sure you want to delete the admission for": "तुम्हाला खात्री आहे की तुम्ही प्रवेश हटवू इच्छिता",
            "Patient Info": "रुग्णाची माहिती",
            "Status Details": "स्थिती तपशील",
            "Current Status": "सध्याची स्थिती",
            "Reason / Detail": "कारण / तपशील",
            "No notes provided for this status change.": "या स्थिती बदलासाठी कोणतीही टीप प्रदान केलेली नाही.",
            "CLOSE": "बंद करा",
            "Please select a start date": "कृपया प्रारंभ तारीख निवडा",
            "Please select an end date": "कृपया अंतिम तारीख निवडा",
            "End date cannot be before start date": "अंतिम तारीख प्रारंभ तारखेच्या आधी असू शकत नाही",
            "Date range cannot exceed 90 days from start date": "तारीख कालावधी प्रारंभ तारखेपासून ९० दिवसांपेक्षा जास्त असू शकत नाही",
            "IPD Datewise Billing Report": "आयपीडी दिनांकानुसार बिलिंग रिपोर्ट",
            "IPD DATEWISE BILLING REPORT": "आयपीडी दिनांकानुसार बिलिंग रिपोर्ट",
            "No data to print": "प्रिंट करण्यासाठी कोणताही डेटा नाही",
            "REPORT PREVIEW": "रिपोर्ट पूर्वावलोकन",
            "TOTAL:": "एकूण:",
            "IPD Billing Statements Report": "आयपीडी बिलिंग स्टेटमेंट रिपोर्ट",
            "Report Date": "रिपोर्ट तारीख",
            "Billing Report": "बिलिंग रिपोर्ट",
            "Summary of": "सारांश",
            "patients found in total": "एकूण रुग्ण आढळले",
            "IPD Patient List": "आयपीडी रुग्ण यादी",
            "Print Bill": "बिल प्रिंट करा",
            "Export Bill": "बिल एक्सपोर्ट करा",
            "WhatsApp Bill": "व्हाट्सएप बिल",
            "Admission Notes / Remarks": "प्रवेश नोट्स / शेरा",
            "Enter remarks... (Please specify reason for Transfer/Cancellation if applicable)": "शेरा प्रविष्ट करा... (लागू असल्यास हस्तांतरण/रद्द करण्याचे कारण नमूद करा)",
            "Delete Admission": "प्रवेश हटवा",
            "Update Admission": "प्रवेश अपडेट करा",
            "Please select a valid Ward/Bed": "कृपया वैध वॉर्ड/बेड निवडा",
            "Please select a Consultant Doctor.": "कृपया सल्लागार डॉक्टर निवडा.",
            "Admission Reason is required.": "प्रवेशाचे कारण आवश्यक आहे.",
            "Enter admission reason": "प्रवेशाचे कारण प्रविष्ट करा",
            "Transfer Information": "बदलीची माहिती",
            "Reason for Transfer": "बदलीचे कारण",
            "e.g., Higher Center Referral": "उदा., उच्च केंद्र रेफरल",
            "Where to Shift (Hospital/Unit)": "कोठे हलवायचे (हॉस्पिटल/युनिट)",
            "e.g., City General Hospital": "उदा., सिटी जनरल हॉस्पिटल",
            "With Whom (Patient Attendant)": "कोणासोबत (रुग्ण मदतनीस)",
            "e.g., Brother / Staff Nurse": "उदा., भाऊ / स्टाफ नर्स",
            "Enter Contact No.": "संपर्क क्रमांक प्रविष्ट करा",
            "Save Transfer": "बदली जतन करा",
            "Before": "जेवणापूर्वी",
            "After": "जेवणानंतर",
            "B": "पूर्वी",
            "A": "नंतर",
            "Breakfast": "न्याहारी",
            "Lunch": "दुपारचे जेवण",
            "Dinner": "रात्रीचे जेवण",
            "Please Add Detailed Clinical Summary before exporting.": "एक्सपोर्ट करण्यापूर्वी कृपया तपशीलवार क्लिनिकल सारांश जोडा.",
            "Please Add Detailed Clinical Summary before printing.": "प्रिंट करण्यापूर्वी कृपया तपशीलवार क्लिनिकल सारांश जोडा.",
            "Availability": "उपलब्धता",
            "Preview": "पूर्वावलोकन",
            "IPD No.": "आयपीडी नंबर",
            "Consultant Doctor": "सल्लागार डॉक्टर",
            "Admission Reason": "प्रवेशाचे कारण",
            "Contact Number": "संपर्क क्रमांक",
            "Condition": "स्थिती",
            "Blood Group": "रक्त गट",
            "Discharge Date": "डिस्चार्ज तारीख",
            "Symptoms": "लक्षणे",
            "IPD ADMISSION DETAILS": "आयपीडी प्रवेश तपशील",
            "Discharged Patient Details": "डिस्चार्ज केलेल्या रुग्णाचे तपशील",
            "Notes / Remarks": "टिपा / शेरा",
            "Enter additional notes or remarks...": "अतिरिक्त टिपा किंवा शेरा प्रविष्ट करा...",
            "Doctor Visit Entry": "डॉक्टर भेट नोंद",
            "Edit Treatment Entry": "उपचार नोंद सुधारा",
            "Weight (kg)": "वजन (किलो)",
            "BPS (Systolic)": "बीपीएस (सिस्टोलिक)",
            "BPD (Diastolic)": "बीपीडी (डायस्टोलिक)",
            "Temp (°F)": "तापमान (°F)",
            "Pulse (bpm)": "नाडी (bpm)",
            "SPO2 (%)": "SPO2 (%)",
            "Enter Diagnosis": "निदान प्रविष्ट करा",
            "Patient Complaint": "रुग्णाची तक्रार",
            "Doctor's Remarks": "डॉक्टरांचा शेरा",
            "Treatment History": "उपचार इतिहास",
            "Date & Time": "तारीख आणि वेळ",
            "Vitals": "व्हायटल्स",
            "Treatment Details": "उपचार तपशील",
            "Actions": "क्रिया",
            "Save All Records": "सर्व रेकॉर्ड साठवा",
            "IPD Medicine Prescription": "आयपीडी औषध प्रिस्क्रिप्शन",
            "History": "इतिहास",
            "Medicine": "औषध",
            "Dosage": "डोस",
            "Dosage (Optional)": "डोस (पर्यायी)",
            "Instructions": "सूचना",
            "Days": "दिवस",
            "Add Medicine": "औषध जोडा",
            "Sr.": "अनु.",
            "Instr": "सूचना",
            "Clear All": "सर्व साफ करा",
            "Save Prescription": "प्रिस्क्रिप्शन साठवा",
            "Export PDF": "PDF एक्सपोर्ट करा",
            "Print": "प्रिंट",
            "Save": "साठवा",
            "Close": "बंद करा",
            "Admission Details": "प्रवेश तपशील",
            "Prescription": "प्रिस्क्रिप्शन",
            "Discharge": "डिस्चार्ज",
            "Patient Name": "रुग्णाचे नाव",
            "Save All": "सर्व साठवा",
            "Wait...": "प्रतीक्षा करा...",
            "No medicines prescribed": "कोणतीही औषधे दिलेली नाहीत",
            "Add Record": "रेकॉर्ड जोडा",
            "Update Visit Record": "भेट रेकॉर्ड अपडेट करा",
            "Update Entry": "नोंद अपडेट करा",
            "Allergy?": "ॲलर्जी?",
            "Search Medicine...": "औषध शोधा...",
            "PRINT SUMMARY": "सारांश प्रिंट करा",
            "EXPORT PDF": "PDF एक्सपोर्ट करा",
            "CLOSE DETAILS": "तपशील बंद करा",
            "Additional Notes:": "अतिरिक्त टीपा:",
            "Patient Profile": "रुग्ण प्रोफाइल",
            "PID": "पीआयडी",
            "Registration No.": "नोंदणी क्र.",
            "Yrs": "वर्षे",
            "IPD Number": "आयपीडी नंबर",
            "Ward / Bed": "वॉर्ड / बेड",
            "Room Floor": "खोलीचा मजला",
            "Admission Info": "प्रवेश माहिती",
            "Consulting Dr.": "सल्लागार डॉ.",
            "Reason for Admission": "प्रवेशाचे कारण",
            "Guardian Details": "पालकांचा तपशील",
            "Relation": "नाते",
            "Clinical Data": "क्लिनिकल डेटा",
            "General": "सामान्य",
            "Patient Vitals": "रुग्णाचे व्हायटल्स",
            "BP": "बीपी",
            "Pulse": "नाडी",
            "Temp": "तापमान",
            "SpO2": "SpO2",
            "Identification & Insurance": "ओळख आणि विमा",
            "Adhar Card": "आधार कार्ड",
            "PAN Card": "पॅन कार्ड",
            "Insurance No.": "विमा क्र.",
            "Discharge Summary": "डिस्चार्ज सारांश",
            "Follow-up Date": "फॉलो-अप तारीख",
            "Doctor's Clinical Summary & Treatment": "डॉक्टरांचा क्लिनिकल सारांश आणि उपचार",
            "Enlarge View": "मोठे करून पहा",
            "No detailed discharge summary recorded.": "कोणताही तपशीलवार डिस्चार्ज सारांश नोंदवलेला नाही.",
            "CLOSE FULL SCREEN": "फुल स्क्रीन बंद करा",
            "Clinical Summary & Treatment": "क्लिनिकल सारांश आणि उपचार",
            "Validation Errors": "व्हॅलिडेशन एरर",
            "Print IPD Summary": "आयपीडी सारांश प्रिंट करा",
            "Prescriptions": "प्रिस्क्रिप्शन",
            "No prescriptions found.": "कोणतेही प्रिस्क्रिप्शन सापडले नाही.",
            "B/L/D": "नाश्ता/दुपार/रात्र",
            "Mobile": "मोबाईल",
            "IPD ID": "आयपीडी आयडी",
            "Delete Record": "रेकॉर्ड डिलीट करा",
            "Are you sure you want to delete this treatment record?": "तुम्हाला खात्री आहे की तुम्ही हे उपचार रेकॉर्ड डिलीट करू इच्छिता?",
            "Delete Prescription": "प्रिस्क्रिप्शन डिलीट करा",
            "Are you sure you want to delete all {{count}} medicines in this prescription?": "तुम्हाला खात्री आहे की तुम्ही या प्रिस्क्रिप्शनमधील सर्व {{count}} औषधे डिलीट करू इच्छिता?",
            "Are you sure you want to delete this medicine?": "तुम्हाला खात्री आहे की तुम्ही हे औषध डिलीट करू इच्छिता?",
            "Edit Admission Details": "प्रवेश तपशील सुधारा",
            "Admission Notes / Remarks": "प्रवेश टिपा / शेरा",
            "Enter remarks... (Please specify reason for Transfer/Cancellation if applicable)": "शेरा प्रविष्ट करा... (लागू असल्यास बदली/रद्द करण्याचे कारण नमूद करा)",
            "Delete Admission": "प्रवेश डिलीट करा",
            "Update Admission": "प्रवेश अपडेट करा",
            "Confirm Delete": "डिलीट करण्याची खात्री करा",
            "Are you sure you want to delete the admission for": "तुम्हाला खात्री आहे की तुम्ही या रुग्णाचा प्रवेश डिलीट करू इच्छिता:",
            "Search Patients": "रुग्ण शोधा",
            "IPD Settings": "आय.पी.डी. सेटिंग्ज",
            "IPD Patient Admission": "आयपीडी रुग्ण प्रवेश",
            "Search Existing patient by Name or Mobile": "नाव किंवा मोबाईलने रुग्ण शोधा",
            "ADD NEW PATIENT": "नवीन रुग्ण जोडा",
            "Remarks / Additional Notes (Please specify reason for Transfer/Cancellation if applicable)": "शेरा / अतिरिक्त टीपा (लागू असल्यास बदली/रद्द करण्याचे कारण स्पष्ट करा)",
            "Bed Availability": "बेडची उपलब्धता",
            "Filter by Floor": "मजल्यानुसार फिल्टर करा",
            "Search or Select Floor": "मजला शोधा किंवा निवडा",
            "Filter by Ward": "वॉर्डनुसार फिल्टर करा",
            "Search or Select Ward": "वॉर्ड शोधा किंवा निवडा",
            "Filter by Bed No": "बेड नंबरनुसार फिल्टर करा",
            "Search bed number...": "बेड नंबर शोधा...",
            "Filter by Status": "स्थितीनुसार फिल्टर करा",
            "Available": "उपलब्ध",
            "Occupied": "भरलेले",
            "Ward Name": "वॉर्डचे नाव",
            "Bed No": "बेड नंबर",
            "Bed Number": "बेड नंबर",
            "Description": "वर्णन",
            "Actions": "कृती",
            "Loading availability...": "उपलब्धता लोड होत आहे...",
            "No matching available beds found": "मिळतेजुळते उपलब्ध बेड सापडले नाहीत",
            "IPD Hospital Configuration": "आयपीडी हॉस्पिटल कॉन्फिगरेशन",
            "Update Details": "तपशील अपडेट करा",
            "Add Details": "तपशील जोडा",
            "Floor Name": "मजल्याचे नाव",
            "Ward / Room": "वॉर्ड / रूम",
            "Enter No": "नंबर प्रविष्ट करा",
            "Configured Wards & Beds": "कॉन्फिगर केलेले वॉर्ड आणि बेड",
            "No configurations found.": "कोणतेही कॉन्फिगरेशन सापडले नाही.",
            "Diagnosis Management": "निदान व्यवस्थापन",
            "Charge Sheet Management": "चार्जेस शीट व्यवस्थापन",
            "Charge Sheet": "चार्जेस शीट",
            "Add New Diagnosis": "नवीन निदान जोडा",
            "Diagnosis Name": "निदानाचे नाव",
            "Enter diagnosis name": "निदानाचे नाव प्रविष्ट करा",
            "Saved Diagnoses": "जतन केलेले निदान",
            "Add New Charge Record": "नवीन चार्जेस रेकॉर्ड जोडा",
            "Update Charge Record": "चार्जेस रेकॉर्ड अपडेट करा",
            "Charge Name": "चार्जेसचे नाव",
            "Charge Code": "चार्जेस कोड",
            "Category": "श्रेणी",
            "Saved Charge Master Details": "जतन केलेले चार्जेस मास्टर तपशील",
            "No charge records found": "कोणतेही चार्जेस रेकॉर्ड सापडले नाहीत",
            "Confirm Save": "जतन करण्याची पुष्टी करा",
            "Confirm Update": "अपडेटची पुष्टी करा",
            "Are you sure you want to save this charge record?": "आपल्याला हे चार्जेस रेकॉर्ड जतन करण्याची खात्री आहे का?",
            "Are you sure you want to update this charge record?": "आपल्याला हे चार्जेस रेकॉर्ड अपडेट करण्याची खात्री आहे का?",
            "Delete Charge Record": "चार्जेस रेकॉर्ड हटवा",
            "Are you sure you want to delete this charge record?": "आपल्याला हे चार्जेस रेकॉर्ड हटवण्याची खात्री आहे का?",
            "Certificate": "प्रमाणपत्र",
            "Saved Prescription": "जतन केलेले प्रिस्क्रिप्शन",
            "Configuration": "कॉन्फिगरेशन",
            "Diagnosis added successfully!": "निदान यशस्वीरित्या जोडले गेले!",
            "Diagnosis updated successfully!": "निदान यशस्वीरित्या अपडेट केले गेले!",
            "Diagnosis deleted successfully!": "निदान यशस्वीरित्या हटवले गेले!",
            "Charge added successfully!": "चार्जेस यशस्वीरित्या जोडले गेले!",
            "Charge updated successfully!": "चार्जेस यशस्वीरित्या अपडेट केले गेले!",
            "Charge deleted successfully!": "चार्जेस यशस्वीरित्या हटवले गेले!",
            "Error fetching diagnoses": "निदान मिळवताना त्रुटी आली",
            "Error saving diagnosis": "निदान जतन करताना त्रुटी आली",
            "Error deleting diagnosis": "निदान हटवताना त्रुटी आली",
            "Error fetching charge master data": "चार्जेस मास्टर डेटा मिळवताना त्रुटी आली",
            "Error saving charge": "चार्जेस जतन करताना त्रुटी आली",
            "Error deleting charge": "चार्जेस हटवताना त्रुटी आली",
            "Diagnosis Name is required": "निदानाचे नाव आवश्यक आहे",
            "Please fill mandatory fields (Name and Amount)": "कृपया अनिवार्य फील्ड भरा (नाव आणि रक्कम)",
            "Edit": "सुधारा",
            "Delete": "हटवा",
            "No diagnoses found": "कोणतेही निदान सापडले नाही",
            "Are you sure you want to delete this diagnosis?": "तुम्हाला खात्री आहे की तुम्ही हे निदान हटवू इच्छिता?",
            "Are you sure you want to save this diagnosis?": "तुम्हाला खात्री आहे की तुम्ही हे निदान जतन करू इच्छिता?",
            "Are you sure you want to update this diagnosis?": "तुम्हाला खात्री आहे की तुम्ही हे निदान अपडेट करू इच्छिता?",
            "Delete Diagnosis": "निदान हटवा",
            "Update Diagnosis": "निदान सुधारा"
        }
    },
    HINDI: {
        translation: {
            "Dashboard": "डैशबोर्ड",
            "APPOINTMENT": "अपॉइंटमेंट",
            "CHECKUP LIST": "चेकअप लिस्ट",
            "PATIENTS": "मरीज़",
            "IPD": "आई.पी.डी.",
            "STAFF": "स्टाफ",
            "PHARMACY": "फार्मेसी",
            "OPD BILLING": "ओ.पी.डी. बिलिंग",
            "OPD REPORTS": "ओ.पी.डी. रिपोर्ट्स",
            "CONFIG": "सेटिंग",
            "LOGOUT": "लॉगआउट",
            "Hospital Information": "अस्पताल की जानकारी",
            "System Configuration": "सिस्टम कॉन्फ़िगरेशन",
            "Privacy Policy": "प्राइवेसी पॉलिसी",
            "Application Language": "एप्लिकेशन भाषा",
            "Save System Config": "कॉन्फ़िगरेशन सहेजें",
            "Save Hospital Info": "जानकारी सहेजें",
            "Billing Statements": "बिलिंग विवरण",
            "Start Date": "शुरू की तारीख",
            "End Date": "अंतिम तिथि",
            "SUBMIT": "सबमिट",
            "CLEAR": "क्लियर",
            "Outstanding Only": "केवल बकाया",
            "Search Name or Mobile": "नाम या मोबाइल खोजें",
            "Payment": "भुगतान",
            "Date": "तारीख",
            "Name": "नाम",
            "Mobile": "मोबाइल",
            "Payment type": "भुगतान का प्रकार",
            "Doctor Name": "डॉक्टर का नाम",
            "Net Amount": "कुल राशि",
            "Amount Received": "प्राप्त राशि",
            "Outstanding Amount": "थकबाकी",
            "Action": "कार्रवाई",
            "Received By": "प्राप्तकर्ता",
            "No Record found": "कोई रिकॉर्ड नहीं मिला",
            "New Bill": "नया बिल",
            "Billing History": "बिलिंग इतिहास",
            "Datewise Billing": "तारीखवार बिलिंग",
            "Total": "कुल",
            "Checkup Reports": "चेकअप रिपोर्ट",
            "Sr No": "क्रम संख्या",
            "Patient Id": "मरीज आईडी",
            "Appointment": "अपॉइंटमेंट",
            "Doctor": "डॉक्टर",
            "Bill": "बिल",
            "Select Size": "आकार चुनें",
            "Orientation": "अभिविन्यास",
            "Portrait": "पोर्ट्रेट",
            "Landscape": "लैंडस्केप",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Format": "प्रारूप",
            "PDF Format": "PDF प्रारूप",
            "Excel Format": "Excel प्रारूप",
            "EXPORT": "एक्सपोर्ट",
            "EXPORTING...": "एक्सपोर्ट हो रहा है...",
            "CLOSE PREVIEW": "पूर्वावलोकन बंद करें",
            "CHECKUP REPORT PREVIEW": "चेकअप रिपोर्ट पूर्वावलोकन",
            "Waiting List Report": "प्रतीक्षा सूची रिपोर्ट",
            "CheckUp Report": "चेकअप रिपोर्ट",
            "Certificate Report": "प्रमाणपत्र रिपोर्ट",
            "Waiting Id": "प्रतीक्षा आईडी",
            "Today's Waiting List Report": "आज की प्रतीक्षा सूची की रिपोर्ट",
            "WAITING LIST REPORT PREVIEW": "प्रतीक्षा सूची रिपोर्ट पूर्वावलोकन",
            "Appointments scheduled": "नियुक्तियाँ निर्धारित हैं",
            "Patients waiting in the queue": "मरीज कतार में प्रतीक्षा कर रहे हैं",
            "What's happening today:": "आज क्या हो रहा है:",
            "Daily Overview": "दैनिक अवलोकन",
            "Completed Today": "आज पूरा हुआ",
            "In Queue": "कतार में",
            "All Time Records": "सर्वकालिक रिकॉर्ड",
            "Pharmacy Inventory": "फार्मेसी इन्वेंट्री",
            "Active Staff": "सक्रिय कर्मचारी",
            "Active IPD Cases": "सक्रिय आईपीडी मामले",
            "Checked Patients": "जाँच लिये गये मरीज",
            "Remaining Patients": "शेष मरीज",
            "Total Patients": "कुल मरीज",
            "Total Medicines": "कुल दवाएं",
            "Total Users": "कुल उपयोगकर्ता",
            "IPD Patients": "आईपीडी मरीज",
            "Welcome": "स्वागत है",
            "Search Patient": "मरीज खोजें",
            "Book Appointment:": "अपॉइंटमेंट बुक करें:",
            "Schedule Appointment": "अपॉइंटमेंट शेड्यूल करें",
            "Waiting List": "प्रतीक्षा सूची",
            "Take Vitals": "वाइटल्स लें",
            "Send to Doctor": "डॉक्टर के पास भेजें",
            "Examination": "जाँच",
            "Weight (kg)": "वजन (किग्रा)",
            "BP Systolic": "बीपी सिस्टोलिक",
            "BP Diastolic": "बीपी डायोलिक",
            "Pulse (bpm)": "पल्स (बीपीएम)",
            "Temp (°F)": "तापमान (°फ़ै)",
            "SpO2 (%)": "SpO2 (%)",
            "Send Inside": "अंदर भेजें",
            "Back": "वापस",
            "Today's Patients": "आज के मरीज",
            "Ready": "तैयार",
            "Check Up": "चेक अप",
            "Search by Name or Mobile...": "नाम या मोबाइल से खोजें...",
            "Register Patient": "मरीज का पंजीकरण करें",
            "Personal Information": "व्यक्तिगत जानकारी",
            "First Name": "प्रथम नाम",
            "Middle Name": "मध्य नाम",
            "Last Name": "अंतिम नाम",
            "Nick Name": "उपनाम",
            "Gender": "लिंग",
            "Date of Birth": "जन्म तिथि",
            "Age (Years)": "उम्र (वर्ष)",
            "Marital Status": "वैवाहिक स्थिति",
            "Identity & Background": "पहचान और पृष्ठभूमि",
            "Religion": "धर्म",
            "Caste": "जाति",
            "Occupation": "व्यवसाय",
            "Pan Card No": "पैन कार्ड नंबर",
            "Aadhar Card No": "आधार कार्ड नंबर",
            "Identification Mark": "पहचान चिन्ह",
            "Contact Information": "संपर्क जानकारी",
            "Mobile Number": "मोबाइल नंबर",
            "Alt Mobile No": "वैकल्पिक मोबाइल नंबर",
            "Email": "ईमेल",
            "Address & Reference": "पता और संदर्भ",
            "Address": "पता",
            "City": "शहर",
            "Pincode": "पिनकोड",
            "Referred By": "इनके द्वारा संदर्भित",
            "Male": "पुरुष",
            "Female": "महिला",
            "Other": "अन्य",
            "Single": "अविवाहित",
            "Married": "विवाहित",
            "Divorced": "तलाकशुदा",
            "Widowed": "विधवा/विधुर",
            "Cancel": "रद्द करें",
            "Submitting...": "सबमिट हो रहा है...",
            "Today's Appointments": "आज की नियुक्तियाँ",
            "Search": "खोजें",
            "New Patient": "नया मरीज",
            "You have": "आपके पास",
            "scheduled and": "निर्धारित हैं और",
            "Appointments": "नियुक्तियाँ",
            "Patients": "मरीज",
            "waiting in the queue.": "कतार में प्रतीक्षा कर रहे हैं।",
            "Patient": "मरीज",
            "Billing": "बिलिंग",
            "Reports": "रिपोर्ट्स",
            "Config": "सेटिंग",
            "NEW PATIENT": "नया मरीज",
            "Patient Name": "मरीज का नाम",
            "No patients found. Search to add to waiting list.": "कोई मरीज नहीं मिला। प्रतीक्षा सूची में जोड़ने के लिए खोजें।",
            "Select": "चुनें",
            "Date:": "तारीख:",
            "Search:": "खोजें:",
            "Enter Name...": "नाम दर्ज करें...",
            "Sr. No.": "क्रम संख्या",
            "Actions": "कार्रवाई",
            "Todays Patients": "आज के मरीज",
            "Weight": "वजन",
            "BP (Sys/Dys)": "बीपी (सिस्टोलिक/डायस्टोलिक)",
            "Temp": "तापमान",
            "Pulse": "पल्स",
            "Status": "स्थिति",
            "No Patients in the waiting list today.": "आज प्रतीक्षा सूची में कोई मरीज नहीं है।",
            "Waiting": "प्रतीक्षा कर रहा है",
            "Save Bill": "बिल सहेजें",
            "Save Prescription": "प्रिस्क्रिप्शन सहेजें",
            "Total Amount:": "कुल राशि:",
            "Amount Received:": "प्राप्त राशि:",
            "Outstanding Amount:": "थकबाकी",
            "Submit": "सबमिट",
            "Export": "एक्सपोर्ट",
            "WhatsApp": "व्हाट्सएप",
            "All Doctors": "सभी डॉक्टर",
            "Are you sure you want to register this patient?": "क्या आप वाकई इस मरीज का पंजीकरण करना चाहते हैं?",
            "Patient already exists in the system.": "मरीज पहले से ही सिस्टम में मौजूद है।",
            "Y": "व",
            "M": "म",
            "D": "दि",
            "O.A": "बकाया",
            "Edit Patient": "मरीज की जानकारी बदलें",
            "bpSystolic": "बीपी सिस्टोलिक",
            "bpDiastolic": "बीपी डायस्टोलिक",
            "Diagnosis": "निदान",
            "Enter Diagnosis": "निदान दर्ज करें",
            "Complaint": "शिकायत",
            "Advice": "सलाह",
            "Please enter prescription name": "कृपया प्रिस्क्रिप्शन का नाम दर्ज करें",
            "Required": "आवश्यक",
            "No Prescription Found...": "कोई प्रिस्क्रिप्शन नहीं मिला...",
            "Available Prescriptions": "उपलब्ध प्रिस्क्रिप्शन",
            "Breakfast": "नाश्ता",
            "Lunch": "दोपहर का भोजन",
            "Dinner": "रात का खाना",
            "Before": "पहले",
            "After": "बाद में",
            "Type": "प्रकार",
            "Medicine": "दवा",
            "Dosage": "खुराक",
            "Search Medicine...": "दवा खोजें...",
            "Instructions": "निर्देश",
            "Days": "दिन",
            "Add Medicine": "दवा जोड़ें",
            "Sr.No.": "क्रम संख्या",
            "No medicines prescribed": "कोई दवा निर्धारित नहीं है",
            "Are you sure you want to clear all added medicines?": "क्या आप वाकई सभी जोड़ी गई दवाओं को हटाना चाहते हैं?",
            "Clear All": "सभी हटाएँ",
            "Instr": "निर्देश",
            "Save": "सहेजें",
            "Clear": "हटाएँ",
            "Bill amount is required": "बिल राशि आवश्यक है",
            "Validation Error": "सत्यापन त्रुटि",
            "Checkup Done...": "चेकअप पूरा हुआ...",
            "Prescribed Medicines:": "निर्धारित दवाएं:",
            "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}": "नमस्ते {{patientName}}, {{hospitalName}} से आपका प्रिस्क्रिप्शन तैयार है।{{medicineText}}\n\nसादर,\n{{hospitalName}}",
            "the hospital": "अस्पताल",
            "Allergy": "एलर्जी",
            "SpO2": "SpO2",
            "SN": "क्रम संख्या",
            "ID": "आईडी",
            "Move Up": "ऊपर ले जाएँ",
            "Move Down": "नीचे ले जाएँ",
            "Delete": "डिलीट करें",
            "Delete Patient": "मरीज को डिलीट करें",
            "Are you sure you want to remove {{name}} from the waiting list?": "क्या आप वाकई {{name}} को प्रतीक्षा सूची से हटाना चाहते हैं?",
            "Patient {{name}} removed from waiting list.": "मरीज {{name}} को प्रतीक्षा सूची से हटा दिया गया है।",
            "Please select a date": "कृपया तारीख चुनें",
            "Unable to load date-wise data": "तारीखवार डेटा लोड करने में असमर्थ",
            "Waiting list has only one patient. Cannot move up or down.": "प्रतीक्षा सूची में केवल एक मरीज है। ऊपर या नीचे नहीं ले जाया जा सकता।",
            "Waiting number changed": "प्रतीक्षा संख्या बदल गई",
            "Waiting number not get updated": "प्रतीक्षा संख्या अपडेट नहीं हुई",
            "Patient added to waiting list successfully!": "मरीज को प्रतीक्षा सूची में सफलतापूर्वक जोड़ दिया गया!",
            "There has been a problem with your fetch operation": "आपके फ़ेच ऑपरेशन में कोई समस्या आई है",
            "No patient records found.": "कोई मरीज रिकॉर्ड नहीं मिला।",
            "View Details": "विवरण देखें",
            "Loading...": "लोड हो रहा है...",
            "Deleting...": "डिलीट हो रहा है...",
            "Back to List": "सूची में वापस जाएं",
            "Are you sure you want to delete {{name}}? This action cannot be undone.": "क्या आप वाकई {{name}} को डिलीट करना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
            "Could not delete patient": "मरीज को डिलीट नहीं किया जा सका",
            "Patient deleted successfully!": "मरीज सफलतापूर्वक डिलीट हो गया!",
            "Patient Information": "मरीज की जानकारी",
            "Hospital Name": "अस्पताल का नाम",
            "Registration No.": "पंजीकरण संख्या",
            "Email Address": "ईमेल पता",
            "Website": "वेबसाइट",
            "Phone Number": "फोन नंबर",
            "Alt Phone Number": "वैकल्पिक फोन नंबर",
            "Speciality": "विशेषता",
            "Tahsil": "तहसील",
            "District": "जिला",
            "State": "राज्य",
            "Country": "देश",
            "Full Address": "पूरा पता",
            "Brief description...": "संक्षिप्त विवरण...",
            "Description": "विवरण",
            "CheckUp Save Bill": "चेकअप बिल सहेजें",
            "Print Certificate": "प्रमाणपत्र प्रिंट करें",
            "OPD Print Bill": "ओपीडी बिल प्रिंट करें",
            "Print Prescription Header": "प्रिस्क्रिप्शन हेडर प्रिंट करें",
            "Print Prescription Footer": "प्रिस्क्रिप्शन फुटर प्रिंट करें",
            "OPD Print Prescription": "ओपीडी प्रिस्क्रिप्शन प्रिंट करें",
            "IPD Print Prescription": "आईपीडी प्रिस्क्रिप्शन प्रिंट करें",
            "IPD Print Bill": "आईपीडी बिल प्रिंट करें",
            "IPD Access": "आईपीडी एक्सेस",
            "Opd Fee": "ओपीडी शुल्क",
            "Prescription Footer": "प्रिस्क्रिप्शन फुटर",
            "Set Prescription Header": "प्रिस्क्रिप्शन हेडर सेट करें",
            "Prescription Language": "प्रिस्क्रिप्शन भाषा",
            "Select Prescription Design": "प्रिस्क्रिप्शन डिज़ाइन चुनें",
            "Select Header Template": "हेडर टेम्पलेट चुनें",
            "Header Template 1": "हेडर टेम्पलेट 1",
            "Header Template 2": "हेडर टेम्पलेट 2",
            "Header Template 3": "हेडर टेम्पलेट 3",
            "Header Template 4": "हेडर टेम्पलेट 4",
            "Preview Full Design": "पूर्ण डिज़ाइन देखें",
            "Preview Header": "हेडर देखें",
            "Application Theme Colour": "एप्लिकेशन थीम का रंग",
            "Teal (Premium)": "टील (प्रीमियम)",
            "Classic Blue": "क्लासिक ब्लू",
            "Natural Green": "प्राकृतिक हरा",
            "Bold Red": "बोल्ड रेड",
            "Royal Purple": "रॉयल पर्पल",
            "Vibrant Indigo": "वाइब्रेंट इंडिगो",
            "Warm Orange": "वार्म ऑरेंज",
            "Professional Navy": "प्रोफेशनल नेवी",
            "Saving...": "सहेज रहा है...",
            "Loading settings...": "सेटिंग्स लोड हो रही हैं...",
            "Effective Date": "प्रभावी तारीख",
            "Last Updated": "अंतिम अपडेट",
            "Introduction": "प्रस्तावना",
            "Our Roles Under the DPDP Act": "DPDP अधिनियम के तहत हमारी भूमिका",
            "How We Store & Secure Data": "हम डेटा कैसे संग्रहीत और सुरक्षित करते हैं",
            "Data Retention and Deletion": "डेटा प्रतिधारण और विलोपन",
            "Your Rights (Data Principal)": "आपके अधिकार (डेटा प्रिंसिपल)",
            "Disclosure to Third Parties": "तीसरे पक्ष को प्रकटीकरण",
            "Grievance Redressal": "शिकायत निवारण",
            "Welcome to Dr Tech Buddy, a Hospital Management System developed and operated by Invensoft Solutions. We are committed to protecting the privacy and security of the data processed through our platform.": "इनवेनसॉफ्ट सॉल्यूशंस द्वारा विकसित और संचालित अस्पताल प्रबंधन प्रणाली डॉ टेक बडी में आपका स्वागत है। हम अपने प्लेटफॉर्म के माध्यम से संसाधित डेटा की गोपनीयता और सुरक्षा की रक्षा के लिए प्रतिबद्ध हैं।",
            "This policy outlines how we handle personal data in compliance with India’s Digital Personal Data Protection (DPDP) Act, 2023 and the DPDP Rules, 2025.": "यह नीति बताती है कि हम भारत के डिजिटल व्यक्तिगत डेटा संरक्षण (DPDP) अधिनियम, 2023 और DPDP नियम, 2025 के अनुपालन में व्यक्तिगत डेटा को कैसे संभालते हैं।",
            "To ensure clarity on legal liability, we distinguish between two types of data:": "कानूनी देयता पर स्पष्टता सुनिश्चित करने के लिए, हम दो प्रकार के डेटा के बीच अंतर करते हैं:",
            "Client Data": "क्लायंट डेटा",
            "Patient Data": "मरीज डेटा",
            "You are the Data Fiduciary": "आप डेटा फिड्यूशरी हैं",
            "You are the Data Processor": "आप डेटा प्रोसेसर हैं",
            "Collected": "एकत्र किया गया",
            "Processed": "संसाधित",
            "Account management, billing, and technical support.": "खाता प्रबंधन, बिलिंग और तकनीकी सहायता।",
            "Patient names, health records, medical history, and treatments.": "मरीजों के नाम, स्वास्थ्य रिकॉर्ड, चिकित्सा इतिहास और उपचार।",
            "Purpose": "उद्देश्य",
            "Responsibility": "जिम्मेदारी",
            "The Hospital is solely responsible for getting patient consent.": "अस्पताल मरीज की सहमति लेने के लिए पूरी तरह जिम्मेदार है।",
            "We employ a 3 tier architecture with strict data isolation to ensure maximum security.": "हम अधिकतम सुरक्षा सुनिश्चित करने के लिए सख्त डेटा अलगाव के साथ 3 टायर आर्किटेक्चर का उपयोग करते हैं।",
            "Database Isolation": "डेटाबेस अलगाव",
            "Server Location": "सर्वर स्थान",
            "Encryption": "एन्क्रिप्शन",
            "Access Control": "प्रवेश नियंत्रण",
            "Every hospital is assigned a separate, isolated database instance.": "प्रत्येक अस्पताल को एक अलग, अलग डेटाबेस इंस्टेंस दिया जाता है।",
            "All data is hosted on Virtual Private Servers (VPS) provided by Hostinger, located within India. We do not transfer health data across borders.": "सभी डेटा होस्टिंगर द्वारा प्रदान किए गए वर्चुअल प्राइवेट सर्वर (VPS) पर होस्ट किया गया है, जो भारत के भीतर स्थित हैं। हम स्वास्थ्य डेटा को सीमाओं के पार स्थानांतरित नहीं करते हैं।",
            "Data is encrypted in transit (SSL/TLS) and at rest where applicable.": "डेटा पारगमन (SSL/TLS) और जहाँ लागू हो वहाँ रेस्ट में एन्क्रिप्ट किया गया है।",
            "Only authorized personnel with valid credentials can access the system. We maintain logs of all access for security audits.": "केवल वैध क्रेडेंशियल वाले अधिकृत कर्मचारी ही सिस्टम तक पहुँच सकते हैं। हम सुरक्षा ऑडिट के लिए सभी एक्सेस के लॉग बनाए रखते हैं।",
            "Retained as long as subscription is active and per Indian tax laws (financial records).": "जब तक सदस्यता सक्रिय है और भारतीय कर कानूनों (वित्तीय रिकॉर्ड) के अनुसार रखा जाता है।",
            "Retained only during subscription. Upon termination:": "केवल सदस्यता के दौरान रखा जाता है। समाप्ति पर:",
            "We provide a full downloadable export of the Hospital's data.": "हम अस्पताल के डेटा का एक पूर्ण डाउनलोड करने योग्य निर्यात प्रदान करते हैं।",
            "We permanently delete the Hospital’s separate database from our VPS within 30 days of contract termination.": "हम अनुबंध समाप्त होने के 30 दिनों के भीतर अपने VPS से अस्पताल के अलग डेटाबेस को स्थायी रूप से हटा देते हैं।",
            "Access the personal data we hold about you (e.g., your profile).": "आपके बारे में हमारे पास मौजूद व्यक्तिगत डेटा तक पहुँचें (जैसे, आपकी प्रोफ़ाइल)।",
            "Request correction of inaccurate details.": "गलत विवरण सुधारने का अनुरोध करें।",
            "Withdraw consent for marketing communications.": "मार्केटिंग संचार के लिए सहमति वापस लें।",
            "Register a grievance regarding your data privacy.": "अपनी डेटा गोपनीयता के संबंध में शिकायत दर्ज करें।",
            "Note: Patients seeking to exercise rights regarding medical records must contact their respective Hospital directly.": "नोट: चिकित्सा रिकॉर्ड के संबंध में अधिकारों का प्रयोग करने के इच्छुक मरीजों को सीधे अपने संबंधित अस्पताल से संपर्क करना चाहिए।",
            "We do not sell or trade personal data. We may share data only with Legal Authorities if required by Indian law or a court order.": "हम व्यक्तिगत डेटा बेचते या व्यापार नहीं करते हैं। हम डेटा केवल कानूनी अधिकारियों के साथ साझा कर सकते हैं यदि भारतीय कानून या अदालत के आदेश द्वारा आवश्यक हो।",
            "If you have any questions or grievances, contact our Data Protection Officer (DPO):": "यदि आपके कोई प्रश्न या शिकायतें हैं, तो हमारे डेटा संरक्षण अधिकारी (DPO) से संपर्क करें:",
            "Chat on WhatsApp": "व्हाट्सएप पर चैट करें",
            "Call Us": "हमें कॉल करें",
            "Email Us": "हमें ईमेल करें",
            "Certificate Management": "प्रमाणपत्र प्रबंधन",
            "Prescription Management": "प्रिस्क्रिप्शन प्रबंधन",
            "Certificate Name": "प्रमाणपत्र का नाम",
            "Certificate Content": "प्रमाणपत्र की सामग्री",
            "Saved Certificates": "सहेजे गए प्रमाणपत्र",
            "Add New Certificate": "नया प्रमाणपत्र जोड़ें",
            "Update Certificate": "प्रमाणपत्र अपडेट करें",
            "Enter certificate name (e.g., Medical Certificate, Fitness Certificate)": "प्रमाणपत्र का नाम दर्ज करें (जैसे, मेडिकल सर्टिफिकेट, फिटनेस सर्टिफिकेट)",
            "Write certificate content here...": "प्रमाणपत्र की सामग्री यहाँ लिखें...",
            "Are you sure you want to delete this certificate?": "क्या आप वाकई इस प्रमाणपत्र को हटाना चाहते हैं?",
            "No certificates found": "कोई प्रमाणपत्र नहीं मिला",
            "Prescription Templates": "प्रिस्क्रिप्शन टेंप्लेट्स",
            "Create Prescription Template": "प्रिस्क्रिप्शन टेंप्लेट बनाएं",
            "Update Prescription Template": "प्रिस्क्रिप्शन टेंप्लेट अपडेट करें",
            "Update Template": "टेंप्लेट अपडेट करें",
            "Add Template": "टेंप्लेट जोड़ें",
            "Special instructions...": "विशेष निर्देश...",
            "No templates found": "कोई टेंप्लेट नहीं मिला",
            "Are you sure you want to delete this template?": "क्या आप वाकई इस टेंप्लेट को हटाना चाहते हैं?",
            "Clear Info": "जानकारी साफ करें",
            "Update Prescription": "प्रिस्क्रिप्शन अपडेट करें",
            "Saved Prescriptions": "सहेजे गए प्रिस्क्रिप्शन",
            "No prescriptions found": "कोई प्रिस्क्रिप्शन नहीं मिला",
            "View": "देखें",
            "Enter Diagnosis...": "निदान दर्ज करें...",
            "Are you sure you want to delete this prescription?": "क्या आप वाकई इस प्रिस्क्रिप्शन को हटाना चाहते हैं?",
            "Clear All Medicines": "सभी दवाएं साफ करें",
            "Delete Prescription": "प्रिस्क्रिप्शन हटाएं",
            "Are you sure you want to clear all added medicines?": "क्या आप वाकई सभी जोड़ी गई दवाओं को साफ करना चाहते हैं?",
            "Search Patient...": "मरीज खोजें...",
            "Sent to Doctor": "डॉक्टर के पास भेजा गया",
            "Confirm": "पुष्टि करें",
            "This action cannot be undone.": "यह क्रिया पूर्ववत नहीं की जा सकती।",
            "Temperature": "तापमान",
            "SpO2": "SpO2",
            "Medical History": "चिकित्सा इतिहास",
            "Full History": "पूरा इतिहास",
            "Get Certificate": "प्रमाणपत्र प्राप्त करें",
            "B/L/D": "ना/दो/रा",
            "Medicine": "दवा",
            "Type": "प्रकार",
            "Dosage": "खुराक",
            "Breakfast": "नाश्ता",
            "Lunch": "दोपहर का भोजन",
            "Dinner": "रात का भोजन",
            "Days": "दिन",
            "Instr": "निर्देश",
            "Medicine Name": "दवा का नाम",
            "Instruction": "निर्देश",
            "Diagnosis": "निदान",
            "Allergy": "एलर्जी",
            "Complaint": "शिकायत",
            "Advice": "सलाह",
            "Select": "चुनें",
            "Print": "प्रिंट",
            "PDF": "PDF",
            "Meds": "दवाएं",
            "Get Your Certificate": "अपना प्रमाणपत्र प्राप्त करें",
            "Patient Name:": "मरीज का नाम:",
            "Certificate Type:": "प्रमाणपत्र का प्रकार:",
            "Select Certificate": "प्रमाणपत्र चुनें",
            "Save Certificate": "प्रमाणपत्र सहेजें",
            "Certificate Preview": "प्रमाणपत्र पूर्वावलोकन",
            "Close Preview": "पूर्वावलोकन बंद करें",
            "Download PDF": "PDF डाउनलोड करें",
            "Export PDF": "PDF एक्सपोर्ट करें",
            "Reg. No:": "पंजीकरण संख्या:",
            "Address:": "पता:",
            "Mobile:": "मोबाइल:",
            "Weight": "वजन",
            "BP (Sys)": "बीपी (सिस)",
            "BP (Dia)": "बीपी (डाय)",
            "Pulse": "पल्स",
            "Temp": "तापमान",
            "Close": "बंद करें",
            "Preview & Print": "पूर्वावलोकन और प्रिंट",
            "Total Amount:": "कुल राशि:",
            "Amount Received:": "प्राप्त राशि:",
            "Outstanding Amount:": "बकाया राशि:",
            "Save Bill": "बिल सहेजें",
            "Save Prescription": "प्रिस्क्रिप्शन सहेजें",
            "Submit": "सबमिट",
            "Submitting...": "सबमिट हो रहा है...",
            "Export": "एक्सपोर्ट",
            "WhatsApp": "व्हाट्सएप",
            "Back": "वापस",
            "Y": "वर्ष",
            "M": "महिना",
            "D": "दिन",
            "Edit Patient": "मरीज को संपादित करें",
            "O.A": "बकाया",
            "Date": "तारीख",
            "Enter Diagnosis": "निदान दर्ज करें",
            "Clear": "साफ करें",
            "Add Medicine": "दवा जोड़ें",
            "Clear All": "सभी दवाएं साफ करें",
            "No medicines prescribed": "कोई दवा निर्धारित नहीं है",
            "Before": "पहले",
            "After": "बाद",
            "BEFORE": "खाने से पहले",
            "AFTER": "खाने के बाद",
            "Date:": "तारीख:",
            "Search:": "खोजें:",
            "Doctor:": "डॉक्टर:",
            "Enter Name...": "नाम दर्ज करें...",
            "All Doctors": "सभी डॉक्टर",
            "Sr. No.": "क्रम संख्या",
            "Actions": "कार्रवाई",
            "Send to Doctor": "डॉक्टर के पास भेजें",
            "Already sent to doctor": "पहले ही डॉक्टर के पास भेज दिया गया है",
            "Sr.No.": "क्र.सं.",
            "Name:": "नाम:",
            "Authorized Signatory": "अधिकृत हस्ताक्षरकर्ता",
            "Addr:": "पता:",
            "bpSystolic": "बीपी सिस्टोलिक",
            "bpDiastolic": "बीपी डायस्टोलिक",
            "Move Up": "ऊपर ले जाएं",
            "Move Down": "नीचे ले जाएं",
            "Search Medicine...": "दवा खोजें...",
            "Instructions": "निर्देश",
            "Prescribed Medicines:": "निर्धारित दवाएं:",
            "the hospital": "अस्पताल",
            "Hello {{patientName}}, your prescription from {{hospitalName}} is ready.{{medicineText}}\n\nRegards,\n{{hospitalName}}": "नमस्ते {{patientName}}, {{hospitalName}} से आपका प्रिस्क्रिप्शन तैयार है।{{medicineText}}\n\nसादर,\n{{hospitalName}}",
            "Validation Error": "सत्यापन त्रुटि",
            "Bill amount is required": "बिल राशि आवश्यक है",
            "Prescription not submitted, please add medicines...": "प्रिस्क्रिप्शन सबमिट नहीं किया गया, कृपया दवाएं जोड़ें...",
            "Checkup Done...": "चेकअप हो गया...",
            "Patient data submitted successfully.": "रोगी डेटा सफलतापूर्वक सबमिट किया गया।",
            "Checkup": "चेकअप",
            "Patient could not be deleted": "मरीज को हटाया नहीं जा सका",
            "Could not fetch patient details. Please try again.": "मरीज की जानकारी नहीं मिल सकी। कृपया पुन: प्रयास करें।",
            "refresh patient list": "मरीज सूची रिफ्रेश करें",
            "Select Patient": "मरीज चुनें",
            "Save Details": "विवरण सहेजें",
            "This patient is already available in today's checkup list!": "यह मरीज आज की चेकअप सूची में पहले से ही उपलब्ध है!",
            "Could not {{action}} patient": "मरीज को {{action}} नहीं किया जा सका",
            "Patient {{action}} successfully!": "मरीज सफलतापूर्वक {{action}}!",
            "added": "जोड़ा गया",
            "updated": "अपडेट किया गया",
            "save": "सहेजें",
            "update": "अपडेट",
            "B/L/D": "ना/दो/रा",
            "Sr No": "क्र.सं.",
            "User Information": "उपयोगकर्ता जानकारी",
            "User-Id": "उपयोगकर्ता-आईडी",
            "User Name": "उपयोगकर्ता नाम",
            "Role": "भूमिका",
            "No user records found.": "कोई उपयोगकर्ता रिकॉर्ड नहीं मिला।",
            "Search User by Name...": "नाम से उपयोगकर्ता खोजें...",
            "New User": "नया उपयोगकर्ता",
            "Medicine Information": "दवा की जानकारी",
            "Medicine-Id": "दवा-आईडी",
            "Manufacturer": "निर्माता",
            "Manufacturer Name": "निर्माता का नाम",
            "Price": "कीमत",
            "Barcode": "बारकोड",
            "Expiry": "समाप्ति",
            "No medicine records found.": "कोई दवा रिकॉर्ड नहीं मिला।",
            "Search Medicine by Name...": "नाम से दवा खोजें...",
            "New Medicine": "नई दवा",
            "Edit Medicine Details": "दवा विवरण संपादित करें",
            "Medicine ID": "दवा आईडी",
            "Medicine Name": "दवा का नाम",
            "Medicine Type": "दवा का प्रकार",
            "Disease": "रोग",
            "Expiry Date": "समाप्ति तिथि",
            "Save Changes": "बदलाव सहेजें",
            "Search Patient": "मरीज खोजें",
            "Enter Name or Mobile": "नाम या मोबाइल दर्ज करें",
            "Patient Prescription": "मरीज का प्रिस्क्रिप्शन",
            "Date & Time": "तारीख और समय",
            "This action cannot be undone.": "यह क्रिया वापस नहीं ली जा सकती।",
            "Confirm": "पुष्टि करें",
            "Select Size": "आकार चुनें",
            "Orientation": "अभिविन्यास",
            "Format": "प्रारूप",
            "Portrait": "पोर्ट्रेट",
            "Landscape": "लैंडस्केप",
            "PDF Format": "PDF प्रारूप",
            "Image Format": "इमेज प्रारूप",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Medicine Basic Info": "दवा की बुनियादी जानकारी",
            "Manufacturing & Pricing": "निर्माण और मूल्य निर्धारण",
            "Inventory Details": "इन्वेंटरी विवरण",
            "Datewise Billing": "तारीखवार बिलिंग",
            "Personal Details": "व्यक्तिगत विवरण",
            "First Name": "पहला नाम",
            "Middle Name": "मध्य नाम",
            "Last Name": "अंतिम नाम",
            "Account & Role": "खाता और भूमिका",
            "Select Role": "भूमिका चुनें",
            "Update User": "उपयोगकर्ता अपडेट करें",
            "Are you sure you want to save the changes to this user information?": "क्या आप वाकई इस उपयोगकर्ता की जानकारी में बदलाव सहेजना चाहते हैं?",
            "Detail": "विवरण",
            "Search": "खोजें",
            "Update Medicine": "दवा अपडेट करें",
            "Are you sure you want to save the changes to this medicine information?": "क्या आप वाकई इस दवा की जानकारी में बदलाव सहेजना चाहते हैं?",
            "Create New Bill": "नया बिल बनाएं",
            "Search Patient By Mobile Number": "मोबाइल नंबर से मरीज खोजें",
            "Expense Name": "खर्च का नाम",
            "Quantity": "मात्रा",
            "Amount": "राशि",
            "Discount(%)": "छूट (%)",
            "Enter transaction no.": "लेनदेन संख्या दर्ज करें",
            "Note": "नोट",
            "Enter Note": "नोट दर्ज करें",
            "Submit with Print": "प्रिंट के साथ सबमिट करें",
            "REPORT PREVIEW": "रिपोर्ट पूर्वावलोकन",
            "Datewise Billing Report": "तारीखवार बिलिंग रिपोर्ट",
            "TOTAL": "कुल",
            "Bill ID": "बिल आईडी",
            "Expenses Info": "खर्च की जानकारी",
            "Expenses Information": "खर्च की जानकारी",
            "No Expenses Added": "कोई खर्च नहीं जोड़ा गया",
            "No Expenses available": "कोई खर्च उपलब्ध नहीं है",
            "Update Billing Details": "बिलिंग विवरण अपडेट करें",
            "Expense Items": "खर्च आइटम",
            "Add Expense": "खर्च जोड़ें",
            "Expense name": "खर्च का नाम",
            "Discount %": "छूट %",
            "Net Amt": "निव्वळ राशि",
            "Actual Amount": "वास्तविक राशि",
            "Total Amount": "कुल राशि",
            "Discount": "छूट",
            "Discount (%)": "छूट (%)",
            "CANCEL": "रद्द करें",
            "UPDATE BILL": "बिल अपडेट करें",
            "UPDATING...": "अपडेट हो रहा है...",
            "Delete Bill": "बिल हटाएं",
            "Update Bill": "बिल अपडेट करें",
            "Outstanding": "बकाया",
            "Billing Date": "बिलिंग तिथि",
            "Payment Type": "भुगतान का प्रकार",
            "Txn No": "लेनदेन संख्या",
            "Update": "अपडेट",
            "Submit": "सबमिट करें",
            "Submitting...": "सबमिट हो रहा है...",
            "DATEWISE BILLING REPORT": "तारीखवार बिलिंग रिपोर्ट",
            "Close": "बंद करें",
            "Select": "चुनें",
            "Clear": "साफ करें",
            "CLEAR": "साफ करें",
            "SUBMIT": "सबमिट करें",
            "PREVIEW": "पूर्वावलोकन",
            "PRINT": "प्रिंट",
            "Select Size": "आकार चुनें",
            "Orientation": "दिशा",
            "Format": "प्रारूप",
            "No patients found": "कोई मरीज नहीं मिला",
            "Error fetching patients": "मरीजों को लाने में त्रुटि",
            "Error fetching billing data": "बिलिंग डेटा लाने में त्रुटि",
            "Bill deleted successfully": "बिल सफलतापूर्वक हटा दिया गया",
            "Error deleting bill": "बिल हटाने में त्रुटि",
            "Please enter expense name before adding new one.": "नया खर्च जोड़ने से पहले कृपया खर्च का नाम दर्ज करें।",
            "Please enter quantity greater than 0.": "कृपया 0 से अधिक मात्रा दर्ज करें।",
            "Please enter valid amount.": "कृपया वैध राशि दर्ज करें।",
            "At least one expense must remain.": "कम से कम एक खर्च रहना चाहिए।",
            "Please select a patient.": "कृपया एक मरीज चुनें।",
            "Please add at least one expense.": "कृपया कम से कम एक खर्च जोड़ें।",
            "Expense name missing (row {{row}}).": "खर्च का नाम गायब है (पंक्ति {{row}})।",
            "Invalid amount in row {{row}}.": "पंक्ति {{row}} में अमान्य राशि।",
            "Quantity must be greater than 0 (row {{row}}).": "मात्रा 0 से अधिक होनी चाहिए (पंक्ति {{row}})।",
            "Please enter valid amount received.": "कृपया प्राप्त वैध राशि दर्ज करें।",
            "Updated successfully": "सफलतापूर्वक अपडेट किया गया",
            "Update failed": "अपडेट विफल रहा",
            "Print Bill": "बिल प्रिंट करें",
            "Export Bill": "बिल एक्सपोर्ट करें",
            "WhatsApp Bill": "व्हाट्सएप बिल",
            "Please select both dates.": "कृपया दोनों तारीखें चुनें।",
            "Failed to fetch billing data": "बिलिंग डेटा लाने में विफल",
            "No data to print": "प्रिंट करने के लिए कोई डेटा नहीं",
            "Cash": "नकद",
            "Card": "कार्ड",
            "UPI": "यूपीआई",
            "Please select a start date": "कृपया आरंभ तिथि चुनें",
            "Please select an end date": "कृपया समाप्ति तिथि चुनें",
            "End date cannot be before start date": "समाप्ति तिथि आरंभ तिथि से पहले नहीं हो सकती",
            "Date range cannot exceed 90 days from start date": "तिथि सीमा आरंभ तिथि से 90 दिनों से अधिक नहीं हो सकती",
            "Consulting Physician": "परामर्श चिकित्सक",
            "Diagnosis Management": "निदान प्रबंधन",
            "Charge Sheet Management": "चार्ज शीट प्रबंधन",
            "Charge Sheet": "चार्ज शीट",
            "Add New Diagnosis": "नया निदान जोड़ें",
            "Diagnosis Name": "निदान का नाम",
            "Enter diagnosis name": "निदान का नाम दर्ज करें",
            "Saved Diagnoses": "सहेजे गए निदान",
            "Add New Charge Record": "नया चार्ज रिकॉर्ड जोड़ें",
            "Update Charge Record": "चार्ज रिकॉर्ड अपडेट करें",
            "Charge Name": "चार्ज का नाम",
            "Charge Code": "चार्ज कोड",
            "Category": "श्रेणी",
            "Saved Charge Master Details": "सहेजे गए चार्ज मास्टर विवरण",
            "No charge records found": "कोई चार्ज रिकॉर्ड नहीं मिला",
            "Confirm Save": "सहेजने की पुष्टि करें",
            "Confirm Update": "अपडेट की पुष्टि करें",
            "Are you sure you want to save this charge record?": "क्या आप वाकई इस चार्ज रिकॉर्ड को सहेजना चाहते हैं?",
            "Are you sure you want to update this charge record?": "क्या आप वाकई इस charge रिकॉर्ड को अपडेट करना चाहते हैं?",
            "Delete Charge Record": "चार्ज रिकॉर्ड हटाएं",
            "Are you sure you want to delete this charge record?": "क्या आप वाकई इस चार्ज रिकॉर्ड को हटाना चाहते हैं?",
            "Certificate": "प्रमाणपत्र",
            "Saved Prescription": "सहेजे गए प्रिस्क्रिप्शन",
            "Configuration": "कॉन्फ़िगरेशन",
            "Diagnosis added successfully!": "निदान सफलतापूर्वक जोड़ा गया!",
            "Diagnosis updated successfully!": "निदान सफलतापूर्वक अपडेट किया गया!",
            "Diagnosis deleted successfully!": "निदान सफलतापूर्वक हटा दिया गया!",
            "Charge added successfully!": "चार्ज सफलतापूर्वक जोड़ा गया!",
            "Charge updated successfully!": "चार्ज सफलतापूर्वक अपडेट किया गया!",
            "Charge deleted successfully!": "चार्ज सफलतापूर्वक हटा दिया गया!",
            "Error fetching diagnoses": "निदान प्राप्त करने में त्रुटि",
            "Error saving diagnosis": "निदान सहेजने में त्रुटि",
            "Error deleting diagnosis": "निदान हटाने में त्रुटि",
            "Error fetching charge master data": "चार्ज मास्टर डेटा प्राप्त करने में त्रुटि",
            "Error saving charge": "चार्ज सहेजने में त्रुटि",
            "Error deleting charge": "चार्ज हटाने में त्रुटि",
            "Diagnosis Name is required": "निदान का नाम आवश्यक है",
            "Please fill mandatory fields (Name and Amount)": "कृपया अनिवार्य फ़ील्ड भरें (नाम और राशि)",
            "Edit": "संपादित करें",
            "Delete": "हटाएं",
            "No diagnoses found": "कोई निदान नहीं मिला",
            "Are you sure you want to delete this diagnosis?": "क्या आप वाकई इस निदान को हटाना चाहते हैं?",
            "Are you sure you want to save this diagnosis?": "क्या आप वाकई इस निदान को सहेजना चाहते हैं?",
            "Are you sure you want to update this diagnosis?": "क्या आप वाकई इस निदान को अपडेट करना चाहते हैं?",
            "Delete Diagnosis": "निदान हटाएं",
            "Update Diagnosis": "निदान अद्यतन करें"
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: "ENGLISH", // default language
        fallbackLng: "ENGLISH",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
